<template>
  <v-row class="d-flex justify-center mt-0">
    <v-col cols="12">
      <!-- Cabecera -->
      <v-expansion-panels v-model="panel">
        <v-expansion-panel readonly>
          <!-- Boton Agregar nueva Factura de Compra -->
          <v-btn
            style="position: absolute; top: -15px; right: 55px; z-index: 1"
            color="success"
            small
            fab
            @click="crearNuevaFC()"
            title="Crear Nueva Factura de Compra"
          >
            <v-icon>fas fa-plus</v-icon>
          </v-btn>
          <!-- Titulo Filtros -->
          <v-expansion-panel-header class="py-0 px-4 text-h5" style="cursor: default">
            <div>
              <v-icon class="mb-1" left>fas fa-filter</v-icon>
              Filtros
            </div>
            <template v-slot:actions>
              <v-btn icon @click.stop="panel = panel === 1 ? 0 : 1">
                <v-icon>fas fa-chevron-down</v-icon>
              </v-btn>
            </template>
          </v-expansion-panel-header>
          <!-- Filtros -->
          <v-expansion-panel-content class="pt-1">
            <v-form @submit.prevent="buscar">
              <!-- Empresa, Proveedor, Fecha Desde y Fecha Hasta -->
              <v-row>
                <v-col cols="12" sm="3" md="3" class="py-1">
                  Empresa
                  <v-autocomplete
                    v-model="selectedEmpresa"
                    item-text="nombre_corto"
                    :items="empresas"
                    hide-details
                    clearable
                    outlined
                    dense
                    return-object
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" :sm="big? 4 : 5" md="3" class="py-1">
                  Proveedor
                  <v-autocomplete
                    v-model="selectedProveedor"
                    item-text="proveedor_nombre"
                    :items="proveedores"
                    hide-details
                    clearable
                    outlined
                    dense
                    return-object
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" :sm="big? 5 : 4" :md="big ? 6 : 3" class="py-1">
                  Fecha
                  <FechaPickerRango
                    v-model="fechaRango"
                    :limpiar.sync="limpiarFecha"
                    :rango_def="rangoDef"
                    promax
                    @changeSize="changeSize"
                    @selectOption="selectOp"
                  />
                </v-col>
                <v-col cols="12" sm="4" md="3" class="py-1">
                  Id Fact Compra
                  <v-text-field
                    v-model="idFactura"
                    outlined
                    dense
                    type="number"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="2" class="py-1">
                  Estado
                  <v-autocomplete
                    v-model="selectedEstado"
                    item-text="estado_nombre"
                    :items="estados"
                    hide-details
                    clearable
                    outlined
                    dense
                    return-object
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="4" md="2" class="py-1">
                  Tipo Fac
                  <v-text-field
                    v-model="tipoFactura"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="2" class="py-1">
                  Emision
                  <v-text-field
                    v-model="emision"
                    outlined
                    dense
                    type="number"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3" class="py-1">
                  Numero
                  <v-text-field
                    v-model="numero"
                    outlined
                    dense
                    type="number"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3" class="py-1">
                  Referencia
                  <v-text-field
                    v-model="referencia"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="py-1">
                  Usuario
                  <v-text-field
                    v-model="usuario"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="py-1">
                  Sucursales
                  <v-autocomplete
                    v-model="selectedSucursal"
                    item-text="nombre"
                    :items="sucursales"
                    hide-details
                    clearable
                    outlined
                    dense
                    return-object
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="pt-1">
                  Estado Control
                  <v-autocomplete
                    v-model="selectedEstadoControl"
                    item-text="estado_control_nombre"
                    :items="estadosControl"
                    hide-details
                    clearable
                    outlined
                    dense
                    return-object
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="3" class="py-1">
                  Orden de Pago
                  <v-text-field
                    v-model="ordenPago"
                    outlined
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="3" md="3" class="py-1">
                  Pago Desde
                  <FechaPicker
                    v-model="fechaDesde"
                    hideDetails
                    :clearable="true"
                  />
                </v-col>
                <v-col cols="6" sm="3" md="3" class="py-1">
                  Pago Hasta
                  <FechaPicker
                    v-model="fechaHasta"
                    hideDetails
                    :clearable="true"
                  />
                </v-col>
                <v-col cols="12" :sm="rangoDef == 4 ? 3 : 6" :md="rangoDef == 4 ? 3 : 6" class="py-1">
                  <BtnFiltro
                    :loading="load"
                    @clear="limpiar()"
                    class="pt-0"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <!-- Listado -->
      <v-data-table
        v-model="selected"
        class="cebra elevation-2 mt-2"
        :headers="headers"
        :items="facturasCompra"
        :loading="load"
        dense
        :search="search"
        @contextmenu:row="clickDerecho"
        :single-select="singleSelect"
        item-key="factura_id"
        show-select
        hide-default-header
        :footer-props="{
          'items-per-page-options': [5, 10, 15, 50],
          'show-first-last-page': true,
          'show-current-page': true
        }"
        @toggle-select-all="selectAllToggle"
        @click:row="rowClick"
      >
        <!-- Buscador en el datatable -->
        <template v-slot:top>
          <v-row class="" v-if="facturasCompra.length != 0">
            <v-col class="ml-2 mb-2">
              <!-- Excel -->
              <download-excel 
                  style="display:inline"
                  :name="`Facturas_Compra_Pagos`"
                  :fields="fact_comp_pagos_header"
                  :fetch="getFactCompPagos"
                  class="pa-0 ma-0"
                >
                  <v-btn
                    class=""
                    title="Descargar Excel"
                    small
                    :disabled="selected.length == 0 && facturasCompra.length == 0"
                  >
                    Excel
                    <v-icon
                      color="green darken-3"
                      small
                      right
                    >
                      fas fa-file-download
                    </v-icon>
                  </v-btn>
                </download-excel>
            </v-col>
          </v-row>
          <v-row class=" pt-2" no-gutters v-if="selected.filter(element => element.selected == 1).length == 0">
            <v-btn color="success" small @click="pagar()" class="ma-2" title="Pagar Facturas" v-if="selected.length > 0"><v-icon class="ma-2" small>fas fa-money-check-alt</v-icon> Pagar</v-btn>
            <v-btn color="info" small @click="seleccionarTodos()" class="ma-2" v-if="selected.length != facturasCompra.length && selected.length > 0"><v-icon class="ma-2" small>far fa-check-circle</v-icon> Seleccionar Todos</v-btn>
            <v-btn color="warning" small @click="quitarTodos()" class="ma-2" v-if="selected.length == facturasCompra.length && facturasCompra.length > 0"><v-icon class="ma-2" small>fas fa-ban</v-icon> Quitar Todos</v-btn>
            <v-btn color="error" small @click="quitarTodos()" class="ma-2" v-if="selected.length > 0 && selected.length != facturasCompra.length"><v-icon class="ma-2" small>fas fa-ban</v-icon> Limpiar Seleccion</v-btn>
            <v-btn color="success" small @click="cambiarEstadoControl()" class="ma-2" v-if="selected.length > 0 && tienePermiso == 1"><v-icon class="ma-2" small>far fa-check-circle</v-icon> Marcar Pagadas</v-btn>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="3" md="3">
              <SearchDataTable
                v-model="search"
                class="pt-2"
              />
            </v-col>
          </v-row>
          <v-row no-gutters v-if="selected.length > 0">
            <v-col cols="12" class="pt-0 pb-0 mt-0 mb-0 pl-2">
              <p>{{ selected.length }} elementos seleccionados de {{ facturasCompra.length }}. Total: ${{ Intl.NumberFormat("de-DE").format(totalSeleccionado) }}</p>
            </v-col>
          </v-row>
        </template>
        <!-- headers personalizados -->
        <template v-slot:header="{ props: { headers } }">
          <thead>
            <tr>
              <th
                v-for="(h, index) in headers"
                :key="index"
                :class="`text-${h.align ? h.align : 'start' }`"
                :style="h.width ? `width: ${h.width}px; min-width: ${h.width}px;` : ''"
              >
                <div v-if="index == 0">
                  <v-checkbox
                    v-if="facturasCompra.length > 0"
                    v-model="check_general"
                    color="gris"
                    class="mt-n1"
                    hide-details
                    @change="check_general ? seleccionarTodos() : quitarTodos()"
                  ></v-checkbox>
                </div>
                <div v-else-if="h.value == 'check_verif'">
                  <v-checkbox
                    v-if="facturasCompra.length > 0"
                    v-model="check_verif"
                    class="mt-n1"
                    hide-details
                    dense
                    @change="check_verif ? seleccionarTodosVerif() : quitarTodosVerif()"
                  ></v-checkbox>
                </div>
                <span v-else>
                  {{ h.text }}
                </span>
              </th>
            </tr>
          </thead>
        </template>
        <!-- Acomodo la emision y numero -->
        <template v-slot:[`item.comprobante`]="{ item }">
          <v-chip :color="item.comprobante.toString().indexOf('NC') != -1 ? 'error' : ''" small>
            {{ item.comprobante }}
          </v-chip>
        </template>
        <!-- Acomodo los totales -->
        <template v-slot:[`item.total_recalculado`]="{ item }">
          <div v-if="roundNumber(item.total_recalculado, 2) > 0">{{ item.abreviatura + ' ' + Intl.NumberFormat("de-DE").format(item.total_recalculado) }}</div>
        </template>
        <template v-slot:[`item.total_real`]="{ item }">
          {{ '$ ' + Intl.NumberFormat("de-DE").format(item.total_real) }}
        </template>
        <!-- Deshabilito los checks de los detalles que ya se encuentren pagados -->
        <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
          <v-simple-checkbox
            :value="isSelected"
            :readonly="item.estado_control_id == 4"
            :disabled="item.estado_control_id == 4"
            @input="select($event)"
          ></v-simple-checkbox>
        </template>
        <template v-slot:[`item.advertencia`]="{ item }">
          <v-btn
            v-if="item.alerta > 0"
            color="orange"
            title="Revisar"
            small
            icon
            @click.stop=""
          >
            <v-icon small>
              fas fa-exclamation-triangle
            </v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.check_verif`]="{ item }">
          <v-checkbox
            v-model="item.check_verif"
            :disabled="item.alerta == 1 || item.estado_codigo != 1"
            hide-details
            dense
            @change="keyVerif++"
            @click.stop
          ></v-checkbox>
        </template>
        <!-- Acciones y modal para confirmar -->
        <template v-slot:[`item.acciones`]="{ item }">
          <v-btn icon small @click.stop="openWindow(item)"><v-icon small color="primary" title="Ver">fas fa-eye</v-icon></v-btn>
          <!-- comentado el 09-04-2025 por MMURILLO, para ganar espacio, se va al menu del click derecho -->
          <!-- <BtnConfirmar
            :icon_button="true"
            :small="true"
            icono="fas fa-ban"
            @action="anularFacturaCompra(item)"
            color="error"
            title="Anular"
            v-if="item.if_anula == 1"
            :texto="item.if_anula == 1 ? `¿Esta seguro de Anular la Factura ${item.factura_id}?` : `No se puede Anular la Factura seleccionada.`"
          /> -->
          <v-btn icon small @click.stop="subirArchivo(item)"><v-icon small :color="parseInt(item.con_archivo) > 0 ? 'success' : 'error'" title="Subir Archivos">fas fa-file-upload</v-icon></v-btn>
          <!-- <v-btn icon small @click="ordenPagoFiles(item)"><v-icon small :color="parseInt(item.orden_pago_id) > 0 ? 'info' : 'error'" title="Orden de Pago">fas fa-file-pdf</v-icon></v-btn> -->
        </template>
        <!-- Msj que se mostrara si no existen resultados -->
        <template v-slot:no-data>
          <v-alert
            class="mx-auto mt-4"
            max-width="400"
            type="warning"
            border="left"
            dense
            text
          >
            No hay datos para los filtros seleccionados
          </v-alert>
        </template>
      </v-data-table>
      <!-- Sección  para marcar Verificadas -->
      <v-row
        :key="keyVerif"
        class="d-flex justify-end mb-3"
      >
        <v-col
          v-if="facturasCompra.filter(fc => fc.check_verif).length > 0"
          class="mt-3 mb-n4 d-flex justify-end align-center"
        >
          <div class="body-2 mr-4">
            {{ facturasCompra.filter(fc => fc.check_verif).length }} elementos seleccionados de {{ facturasCompra.length }}
            <span v-if="facturasCompra.filter(fc => fc.check_verif).length != facturasCompra.length">
              -
              <v-hover v-slot="{ hover }">
                <a
                  :class="hover ? 'text-decoration-underline' : ''"
                  @click="seleccionarTodosVerif()"
                >
                  Seleccionar todas
                </a>
              </v-hover>
            </span>
            -
            <v-hover v-slot="{ hover }">
              <a
                class="orange--text"
                :class="hover ? 'text-decoration-underline' : ''"
                @click="quitarTodosVerif()"
              >
                Limpiar selección
              </a>
            </v-hover>
          </div>
          <v-btn
            color="success"
            small
            @click="marcarVerificadas()"
          >
            <v-icon small left>fas fa-check</v-icon>
            Marcar verificadas
          </v-btn>
        </v-col>
      </v-row>
      <!-- Modal Subir Archivos -->
      <ModalSubirArchivos
        :ruta="ruta_carpeta"
        :activo="dialogSubirArchivo"
        :facturaId="facturaSeleccionada"
        @cerrarModalSA="closeModalSubirArchivo()"
        @refrescarTabla="buscar()"
      />
      <!-- Modal Subir Archivos Factura Seleccionada -->
      <ModalSubirArchivos
        :ruta="ruta_carpeta"
        :activo="dialogSubirFile"
        :facturaId="facturaSeleccionada"
        @cerrarModalSA="closeModalSubirArchivo()"
        @refrescarTabla="setFacturaFile"
      />
      <!-- Modal Subir Archivos -->
      <ModalUploadImgGral 
        :datos="dialogSubirImgs"
        @setearModalUpImg="setModalUpImg"
      />
    </v-col>
    <!-- Seleccion de una Factura de Compra -->
    <v-col 
      cols="12" 
      class="pt-0"
    >
      <!-- Fila seleccionada en el DataTable -->
      <v-expand-transition>
        <section id="unaFC">
          <v-card
            flat
            v-if="selected.length == 1 && selected[0].selected == 1"
          >
            <v-card-title class="d-flex justify-end pb-0 pt-1 px-2">
              <v-btn
                title="Cerrar detalle"
                icon
                small
                @click="selected = []"
              >
                <v-icon>fas fa-times</v-icon>
              </v-btn>
            </v-card-title>
            <!-- Datos de la Factura Seleccionada -->
            <v-card-text class="pt-0 px-0" style="width: 100%">
              <!-- Listado de Factura seleccionada -->
              <v-data-table
                class="mb-2"
                style="width: 100%"
                :headers="headerSelect"
                :items="selected"
                hide-default-footer
                sort-desc
                dense
              >
                <!-- Acomodo la emision y numero -->
                <template v-slot:[`item.comprobante`]="{ item }">
                  <v-chip :color="item.comprobante.toString().indexOf('NC') != -1 ? 'error' : ''" small>
                    {{ item.comprobante }}
                  </v-chip>
                </template>
                <!-- Acomodo los totales -->
                <template v-slot:[`item.total_recalculado`]="{ item }">
                  <div v-if="roundNumber(item.total_recalculado, 2) > 0">{{ item.abreviatura + ' ' + Intl.NumberFormat("de-DE").format(item.total_recalculado) }}</div>
                </template>
                <template v-slot:[`item.total_real`]="{ item }">
                  {{ formatMoney(item.total_real) }}
                </template>
              </v-data-table>
              <!-- Detalles de la Factura -->
              <v-row :no-gutters="$vuetify.breakpoint.xs" v-if="objetoNoVacio(factura)" class="pt-4">
                <!-- Datos Editables de la Factura -->
                <v-col cols="12" sm="6">
                  <!-- Empresa, Proveedor y Sucursal -->
                  <v-row class="d-flex justify-start">
                    <v-col cols="12" :sm="multiCuentas.length > 0 ? '6' : '8'" class="py-2 d-flex">
                      <v-text-field
                        :value="factura.proveedor_nombre"
                        outlined
                        dense
                        type="text"
                        readonly
                        disabled
                        filled
                        hide-details
                        label="Proveedor"
                      ></v-text-field>
                      <v-tooltip color="primary" left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="info"
                            class="ml-2"
                            style="cursor: pointer"
                            small
                          >
                            fas fa-info-circle
                          </v-icon>
                        </template>
                        <div>
                          Cuit: <strong style="margin-left: 17px">{{factura.proveedor_cuit}}</strong>
                        </div>
                      </v-tooltip>
                    </v-col>
                    <v-col cols="12" sm="6" class="py-2 d-flex" v-if="multiCuentas.length > 0">
                      <v-autocomplete
                        v-model="factura.proveedor_bejerman_codigo"
                        item-text="proveedor_nombre"
                        item-value="proveedor_codigo"
                        :items="multiCuentas"
                        hide-details
                        outlined
                        dense
                        label="Prov. Bejerman"
                        clearable
                        :disabled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :readonly="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :filled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        @change="setProvBejerman()"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" class="py-2" v-else>
                      <v-autocomplete
                        v-model="factura.sucursal_codigo"
                        item-text="nombre"
                        item-value="id"
                        :items="sucursales"
                        hide-details
                        outlined
                        dense
                        label="Sucursal"
                        clearable
                        :disabled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :readonly="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :filled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <!-- Fechas, Emision y Numero -->
                  <v-row class="d-flex justify-start">
                    <v-col cols="12" sm="4" class="py-2" v-if="multiCuentas.length > 0">
                      <v-autocomplete
                        v-model="factura.sucursal_codigo"
                        item-text="nombre"
                        item-value="id"
                        :items="sucursales"
                        hide-details
                        outlined
                        dense
                        label="Sucursal"
                        clearable
                        :disabled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :readonly="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :filled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" class="py-2">
                      <FechaPicker
                        v-model="factura.fecha"
                        hideDetails
                        label="Fecha"
                        :disabled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :readonly="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :filled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                      />
                    </v-col>
                    <v-col cols="12" sm="4" class="py-2">
                      <FechaPicker
                        v-model="factura.fecha_contable"
                        hideDetails
                        label="F. Cont."
                        :disabled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :readonly="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :filled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                      />
                    </v-col>
                    <v-col cols="12" sm="2" class="py-2" v-if="multiCuentas.length == 0">
                      <v-text-field
                        v-model="factura.emision"
                        outlined
                        dense
                        type="text"
                        hide-details
                        label="Emis."
                        :disabled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :readonly="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :filled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" class="py-2" v-if="multiCuentas.length == 0">
                      <v-text-field
                        v-model="factura.numero"
                        outlined
                        dense
                        type="number"
                        hide-details
                        label="Num."
                        :disabled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :readonly="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :filled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- Tipo de Factura y Referencia -->
                  <v-row class="d-flex justify-start">
                    <v-col cols="12" sm="2" class="py-2" v-if="multiCuentas.length > 0">
                      <v-text-field
                        v-model="factura.emision"
                        outlined
                        dense
                        type="text"
                        hide-details
                        label="Emis."
                        :disabled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :readonly="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :filled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2" class="py-2" v-if="multiCuentas.length > 0">
                      <v-text-field
                        v-model="factura.numero"
                        outlined
                        dense
                        type="number"
                        hide-details
                        label="Num."
                        :disabled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :readonly="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :filled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" :sm="multiCuentas.length > 0 ? '3' : '4'" class="py-2">
                      <v-autocomplete
                        v-model="factura.tipo_factura_id"
                        :item-text="tipoCompFormat"
                        item-value="tipo_id"
                        :items="tiposComp"
                        hide-details
                        outlined
                        dense
                        label="Tip. Comp."
                        clearable
                        :disabled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :readonly="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :filled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" :sm="multiCuentas.length > 0 ? '5' : '8'" class="py-2">
                      <v-text-field
                        v-model="factura.referencia"
                        outlined
                        dense
                        type="text"
                        hide-details
                        label="Referencia"
                        :disabled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :readonly="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :filled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- Items, Cond de Pago y Estado de Control -->
                  <v-row class="d-flex justify-start">
                    <v-col cols="12" sm="2" class="py-2">
                      <v-text-field
                        :value="tiposItems.filter(element => element.tipo_id == factura.tipo_ingreso)[0].abreviatura"
                        outlined
                        dense
                        type="text"
                        hide-details
                        label="Items"
                        readonly
                        disabled
                        filled
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" class="py-2">
                      <v-autocomplete
                        v-model="factura.condicion_pago_bejerman"
                        item-text="descripcion"
                        item-value="id"
                        :items="cond_pago"
                        hide-details
                        outlined
                        dense
                        label="C. Pago"
                        :disabled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :readonly="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :filled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4" class="py-2">
                      <v-autocomplete
                        v-model="factura.estado_control_id"
                        item-text="estado_control_nombre"
                        item-value="estado_control_id"
                        :item-disabled="(item) => item.seleccionable == 0"
                        :items="estadosControl"
                        hide-details
                        outlined
                        dense
                        label="Est. Ctrl."
                        :disabled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :readonly="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                        :filled="factura.estado_control_id == 4 || factura.estado_codigo == 3"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <!-- Totales, Moneda y Cotización -->
                  <v-row class="d-flex justify-start">
                    <v-col cols="12" sm="4" class="py-2">
                      <TextFieldMoney
                        v-model="factura.total"
                        :label="`${(cadenaVacia(factura.moneda_id) || factura.moneda_id == 0 || factura.moneda_id == 1) ? 'T. Pesos' : `T. Mon. Ext.`}`"
                        v-bind:properties="{ prefix: '$',
                          'validate-on-blur': boolString == 'true',
                          'readonly': boolString == 'true',
                          'filled': boolString == 'true',
                          'hide-details': boolString == 'true' }"
                      />
                    </v-col>
                    <v-col cols="12" sm="4" class="py-2" v-if="!(cadenaVacia(factura.moneda_id) || factura.moneda_id == 0 || factura.moneda_id == 1)">
                      <TextFieldMoney
                        v-model="totalPesos"
                        :label="`T. Pesos`"
                        v-bind:properties="{ prefix: '$',
                          'validate-on-blur': boolString == 'true',
                          'readonly': boolString == 'true',
                          'filled': boolString == 'true',
                          'hide-details': boolString == 'true' }"
                      />
                    </v-col>
                    <v-col cols="12" sm="4" class="py-2 d-flex" v-if="!(cadenaVacia(factura.moneda_id) || factura.moneda_id == 0 || factura.moneda_id == 1)">
                      <v-tooltip color="primary" left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            color="info"
                            class="mr-2"
                            style="cursor: pointer"
                            small
                          >
                            fas fa-info-circle
                          </v-icon>
                        </template>
                        <div>
                          Moneda: <strong style="margin-left: 17px">{{ (cadenaVacia(factura.moneda_id) || factura.moneda_id == 0 || factura.moneda_id == 1) ? monedas.filter(element => element.moneda_id == 1)[0].moneda_nombre : monedas.filter(element => element.moneda_id == factura.moneda_id)[0].moneda_nombre }}</strong>
                        </div>
                      </v-tooltip>
                      <TextFieldMoney
                        v-model="factura.cotizacion"
                        label="Cot."
                        @blur="calcularPesos()"
                        v-bind:properties="{ prefix: '$',
                          'validate-on-blur': boolString == 'true',
                          'readonly': (factura.estado_control_id == 4 || factura.estado_codigo == 3) ? boolString == 'true' : boolString == 'false',
                          'filled': (factura.estado_control_id == 4 || factura.estado_codigo == 3) ? boolString == 'true' : boolString == 'false',
                          'hide-details': boolString == 'true' }"
                      />
                    </v-col>
                  </v-row>
                  <!-- Convertir a Pesos Argentinos -->
                  <v-row class="d-flex justify-start" v-if="!cadenaVacia(factura.moneda_id) && factura.moneda_id != 1 && factura.moneda_id != 0">
                    <v-col cols="12" class="pt-0">
                      <v-checkbox
                        v-model="pesosArg"
                        :true-value="1"
                        :false-value="0"
                        hide-details
                        dense
                        label="Total en Pesos Argentinos"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <!-- Detalles de Factura -->
                  <v-row :no-gutters="$vuetify.breakpoint.xs">
                    <v-col cols="12" class="pt-0">
                      <v-card
                        flat
                        outlined
                      >
                        <v-card-title class="pt-0 pb-0 d-flex">
                          Detalles
                          <v-spacer></v-spacer>
                          <v-tooltip top v-if="factura.estado_control_id != 4 && factura.estado_codigo != 3">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon small v-on="on" v-bind="attrs" color="success" @click="agregarDetalles()"><v-icon small>fas fa-plus-circle</v-icon></v-btn>
                            </template>
                            <span>Agregar Detalles</span>
                          </v-tooltip>
                        </v-card-title>
                        <v-card-text>
                          <v-data-table
                            class="cebra elevation-2"
                            :headers="pesosArg == 0 ? headerFC : headerFCPesos"
                            :items="factura.detalles"
                            dense
                            hide-default-footer
                            :key="keyDetalles"
                          >
                            <!-- Importe -->
                            <template v-slot:[`item.importe`]="{ item }">
                              {{ formatMoney(item.importe) }}
                            </template>
                            <!-- Iva -->
                            <template v-slot:[`item.iva`]="{ item }">
                              {{ formatMoney(item.iva) }}
                            </template>
                            <!-- Importe Pesos -->
                            <template v-slot:[`item.importe_pesos`]="{ item }">
                              {{ formatMoney(item.importe_pesos) }}
                            </template>
                            <!-- Iva Pesos -->
                            <template v-slot:[`item.iva_pesos`]="{ item }">
                              {{ formatMoney(item.iva_pesos) }}
                            </template>
                            <!-- Acciones -->
                            <template v-slot:[`item.acciones`]="{ item }" v-if="factura.estado_control_id != 4 && factura.estado_codigo != 3">
                              <v-tooltip top color="info">
                                <template v-slot:activator="{ on }">
                                  <v-btn small icon color="info" v-on="on">
                                    <v-icon small>fas fa-info-circle</v-icon>
                                  </v-btn>
                                </template>
                                <template v-if="pesosArg == 0">
                                  <ul>
                                    <li>Código: {{ item.concepto_codigo }}</li>
                                    <li>Precio Unit.: {{ formatMoney(item.precio) }}</li>
                                    <li>Cantidad: {{ item.cantidad }}</li>
                                    <li>Neto: {{ formatMoney(item.neto) }}</li>
                                    <li>Tasa: {{ Intl.NumberFormat("de-DE").format(item.tasa * 100) }}%</li>
                                  </ul>
                                </template>
                                <template v-else>
                                  <li>Código: {{ item.concepto_codigo }}</li>
                                  <li>Precio Unit.: {{ formatMoney(item.precio_pesos) }}</li>
                                  <li>Cantidad: {{ item.cantidad }}</li>
                                  <li>Neto: {{ formatMoney(item.neto_pesos) }}</li>
                                  <li>Tasa: {{ Intl.NumberFormat("de-DE").format(item.tasa * 100) }}%</li>
                                </template>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn small icon color="warning" @click="editarDetalle(item)" v-on="on">
                                    <v-icon small>fas fa-edit</v-icon>
                                  </v-btn>
                                </template>
                                <span>Editar</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn small icon color="error" @click="quitarDetalle(item)" v-on="on">
                                    <v-icon small>far fa-times-circle</v-icon>
                                  </v-btn>
                                </template>
                                <span>Quitar</span>
                              </v-tooltip>
                            </template>
                            <!-- Sin Detalles -->
                            <template v-slot:no-data>
                              <v-alert
                                class="mx-auto mt-4"
                                max-width="400"
                                type="warning"
                                border="left"
                                dense
                                text
                              >
                                No hay detalles asociados a la Factura
                              </v-alert>
                            </template>
                            <!-- Ultima row para el total -->
                            <template slot="body.append">
                              <template v-if="pesosArg == 0">
                                <tr class="font-weight-bold">
                                  <th></th>
                                  <th class="text-right">Sub Total</th>
                                  <th class="text-right">{{ formatMoney(factura.detalles.reduce((sum, item) => sum + roundNumber(item.importe, 6), 0)) }}</th>
                                  <th></th>
                                </tr>
                                <tr class="font-weight-bold">
                                  <th class="text-right">Iva 10.5%: {{ formatMoney(factura.detalles.filter(element => element.gravamen_codigo == 2).reduce((sum, item) => sum + roundNumber(item.iva, 6), 0)) }}</th>
                                  <th class="text-right">Iva 21%: {{ formatMoney(factura.detalles.filter(element => element.gravamen_codigo == 1).reduce((sum, item) => sum + roundNumber(item.iva, 6), 0)) }}</th>
                                  <th class="text-right">Iva 27%: {{ formatMoney(factura.detalles.filter(element => element.gravamen_codigo == 4).reduce((sum, item) => sum + roundNumber(item.iva, 6), 0)) }}</th>
                                  <th class="text-right">Ret. Esp.: {{ formatMoney(factura.retenciones.reduce((sum, item) => sum + roundNumber(item.importe, 6), 0)) }}</th>
                                </tr>
                                <tr class="font-weight-bold">
                                  <th></th>
                                  <th></th>
                                  <th class="text-right">Total</th>
                                  <th class="text-right">
                                    <div class="d-flex">
                                      <v-tooltip color="primary" top v-if="Math.abs(roundNumber(factura.total, 6) - (factura.detalles.reduce((sum, item) => sum + roundNumber(item.importe, 6), 0) + factura.detalles.filter(element => element.gravamen_codigo == 2).reduce((sum, item) => sum + roundNumber(item.iva, 6), 0) + factura.detalles.filter(element => element.gravamen_codigo == 1).reduce((sum, item) => sum + roundNumber(item.iva, 6), 0) + factura.detalles.filter(element => element.gravamen_codigo == 4).reduce((sum, item) => sum + roundNumber(item.iva, 6), 0) + factura.retenciones.reduce((sum, item) => sum + roundNumber(item.importe, 6), 0))) > 1">
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            color="warning"
                                            class="mr-2"
                                            style="cursor: pointer"
                                            small
                                          >
                                            fas fa-exclamation-triangle
                                          </v-icon>
                                        </template>
                                        <span>El Total de la Factura {{ formatMoney(factura.total) }} difiere con el Total Calculado {{ formatMoney(factura.detalles.reduce((sum, item) => sum + roundNumber(item.importe, 6), 0) + factura.detalles.filter(element => element.gravamen_codigo == 2).reduce((sum, item) => sum + roundNumber(item.iva, 6), 0) + factura.detalles.filter(element => element.gravamen_codigo == 1).reduce((sum, item) => sum + roundNumber(item.iva, 6), 0) + factura.detalles.filter(element => element.gravamen_codigo == 4).reduce((sum, item) => sum + roundNumber(item.iva, 6), 0) + factura.retenciones.reduce((sum, item) => sum + roundNumber(item.importe, 6), 0)) }} en más de $1. Revisar.</span>
                                      </v-tooltip>
                                      {{ formatMoney(factura.detalles.reduce((sum, item) => sum + roundNumber(item.importe, 6), 0) + 
                                        factura.detalles.filter(element => element.gravamen_codigo == 2).reduce((sum, item) => sum + roundNumber(item.iva, 6), 0) +
                                        factura.detalles.filter(element => element.gravamen_codigo == 1).reduce((sum, item) => sum + roundNumber(item.iva, 6), 0) +
                                        factura.detalles.filter(element => element.gravamen_codigo == 4).reduce((sum, item) => sum + roundNumber(item.iva, 6), 0) +
                                        factura.retenciones.reduce((sum, item) => sum + roundNumber(item.importe, 6), 0))
                                      }}
                                    </div>
                                  </th>
                                </tr>
                              </template>
                              <template v-else>
                                <tr class="font-weight-bold">
                                  <th></th>
                                  <th class="text-right">Sub Total</th>
                                  <th class="text-right">{{ formatMoney(factura.detalles.reduce((sum, item) => sum + roundNumber(item.importe_pesos, 6), 0)) }}</th>
                                  <th></th>
                                </tr>
                                <tr class="font-weight-bold">
                                  <th class="text-right">Iva 10.5%: {{ formatMoney(factura.detalles.filter(element => element.gravamen_codigo == 2).reduce((sum, item) => sum + roundNumber(item.iva_pesos, 6), 0)) }}</th>
                                  <th class="text-right">Iva 21%: {{ formatMoney(factura.detalles.filter(element => element.gravamen_codigo == 1).reduce((sum, item) => sum + roundNumber(item.iva_pesos, 6), 0)) }}</th>
                                  <th class="text-right">Iva 27%: {{ formatMoney(factura.detalles.filter(element => element.gravamen_codigo == 4).reduce((sum, item) => sum + roundNumber(item.iva_pesos, 6), 0)) }}</th>
                                  <th class="text-right">Ret. Esp.: {{ formatMoney(factura.retenciones.reduce((sum, item) => sum + roundNumber(item.importe_pesos, 6), 0)) }}</th>
                                </tr>
                                <tr class="font-weight-bold">
                                  <th></th>
                                  <th></th>
                                  <th class="text-right">Total</th>
                                  <th class="text-right">
                                    <div class="d-flex">
                                      <v-tooltip color="primary" top v-if="Math.abs(roundNumber(totalPesos, 6) - (factura.detalles.reduce((sum, item) => sum + roundNumber(item.importe_pesos, 6), 0) + factura.detalles.filter(element => element.gravamen_codigo == 2).reduce((sum, item) => sum + roundNumber(item.iva_pesos, 6), 0) + factura.detalles.filter(element => element.gravamen_codigo == 1).reduce((sum, item) => sum + roundNumber(item.iva_pesos, 6), 0) + factura.detalles.filter(element => element.gravamen_codigo == 4).reduce((sum, item) => sum + roundNumber(item.iva_pesos, 6), 0) + factura.retenciones.reduce((sum, item) => sum + roundNumber(item.importe_pesos, 6), 0))) > 1">
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            color="warning"
                                            class="mr-2"
                                            style="cursor: pointer"
                                            small
                                          >
                                            fas fa-exclamation-triangle
                                          </v-icon>
                                        </template>
                                        <span>El Total de la Factura {{ formatMoney(totalPesos) }} difiere con el Total Calculado {{ formatMoney(factura.detalles.reduce((sum, item) => sum + roundNumber(item.importe_pesos, 6), 0) + factura.detalles.filter(element => element.gravamen_codigo == 2).reduce((sum, item) => sum + roundNumber(item.iva_pesos, 6), 0) + factura.detalles.filter(element => element.gravamen_codigo == 1).reduce((sum, item) => sum + roundNumber(item.iva_pesos, 6), 0) + factura.detalles.filter(element => element.gravamen_codigo == 4).reduce((sum, item) => sum + roundNumber(item.iva_pesos, 6), 0) + factura.retenciones.reduce((sum, item) => sum + roundNumber(item.importe_pesos, 6), 0)) }} en más de $1. Revisar.</span>
                                      </v-tooltip>
                                      {{ formatMoney(factura.detalles.reduce((sum, item) => sum + roundNumber(item.importe_pesos, 6), 0) + 
                                        factura.detalles.filter(element => element.gravamen_codigo == 2).reduce((sum, item) => sum + roundNumber(item.iva_pesos, 6), 0) +
                                        factura.detalles.filter(element => element.gravamen_codigo == 1).reduce((sum, item) => sum + roundNumber(item.iva_pesos, 6), 0) +
                                        factura.detalles.filter(element => element.gravamen_codigo == 4).reduce((sum, item) => sum + roundNumber(item.iva_pesos, 6), 0) +
                                        factura.retenciones.reduce((sum, item) => sum + roundNumber(item.importe_pesos, 6), 0))
                                      }}
                                    </div>
                                  </th>
                                </tr>
                              </template>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <!-- Retenciones Especiales -->
                  <v-row :no-gutters="$vuetify.breakpoint.xs">
                    <v-col cols="12" class="pt-0">
                      <v-card
                        flat
                        outlined
                      >
                        <v-card-title class="pt-0 pb-0 d-flex">
                          Ret. Esp.
                          <v-spacer></v-spacer>
                          <v-tooltip top v-if="factura.estado_control_id != 4 && factura.estado_codigo != 3">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon small v-on="on" v-bind="attrs" color="success" @click="agregarRetenciones()"><v-icon small>fas fa-plus-circle</v-icon></v-btn>
                            </template>
                            <span>Agregar Retenciones</span>
                          </v-tooltip>
                        </v-card-title>
                        <v-card-text>
                          <v-data-table
                            class="cebra elevation-2"
                            :headers="pesosArg == 0 ? headerRet : headerRetPesos"
                            :items="factura.retenciones"
                            dense
                            hide-default-footer
                            :key="keyRetenciones"
                          >
                            <!-- Importe -->
                            <template v-slot:[`item.importe`]="{ item }">
                              {{ formatMoney(item.importe) }}
                            </template>
                            <!-- Importe Pesos -->
                            <template v-slot:[`item.importe_pesos`]="{ item }">
                              {{ formatMoney(item.importe_pesos) }}
                            </template>
                            <!-- Sin Detalles -->
                            <template v-slot:no-data>
                              <v-alert
                                class="mx-auto mt-4"
                                max-width="400"
                                type="warning"
                                border="left"
                                dense
                                text
                              >
                                No hay Retenciones asociadas a la Factura
                              </v-alert>
                            </template>
                            <!-- Acciones -->
                            <template v-slot:[`item.acciones`]="{ item }" v-if="factura.estado_control_id != 4 && factura.estado_codigo != 3">
                              <v-tooltip top color="info">
                                <template v-slot:activator="{ on }">
                                  <v-btn small icon color="info" v-on="on">
                                    <v-icon small>fas fa-info-circle</v-icon>
                                  </v-btn>
                                </template>
                                <ul>
                                  <li>Código: {{ item.codigo }}</li>
                                </ul>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn small icon color="warning" @click="editarRetEsp(item)" v-on="on">
                                    <v-icon small>fas fa-edit</v-icon>
                                  </v-btn>
                                </template>
                                <span>Editar</span>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn small icon color="error" @click="quitarRetEsp(item)" v-on="on">
                                    <v-icon small>far fa-times-circle</v-icon>
                                  </v-btn>
                                </template>
                                <span>Quitar</span>
                              </v-tooltip>
                            </template>
                            <!-- Ultima row para el total -->
                            <template slot="body.append">
                              <template v-if="pesosArg == 0">
                                <tr class="font-weight-bold">
                                  <th></th>
                                  <th></th>
                                  <th class="text-right">Total Ret. Esp.:</th>
                                  <th class="text-right">{{ formatMoney(factura.retenciones.reduce((sum, item) => sum + roundNumber(item.importe, 6), 0)) }}</th>
                                </tr>
                              </template>
                              <template v-else>
                                <tr class="font-weight-bold">
                                <th></th>
                                <th></th>
                                <th class="text-right">Total Ret. Esp.:</th>
                                <th class="text-right">{{ formatMoney(factura.retenciones.reduce((sum, item) => sum + roundNumber(item.importe_pesos, 6), 0)) }}</th>
                              </tr>
                              </template>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                  <!-- Pagos -->
                  <v-row :no-gutters="$vuetify.breakpoint.xs">
                    <v-col cols="12" class="pt-0">
                      <v-card
                        flat
                        outlined
                      >
                        <v-card-title class="pt-0 pb-0 d-flex">
                          Pagos
                          <v-spacer></v-spacer>
                          <v-tooltip top v-if="factura.estado_control_id != 4 && factura.estado_codigo != 3">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon small v-on="on" v-bind="attrs" color="success" @click="agregarPagos()"><v-icon small>fas fa-plus-circle</v-icon></v-btn>
                            </template>
                            <span>Agregar Pagos</span>
                          </v-tooltip>
                        </v-card-title>
                        <v-card-text>
                          <v-data-table
                            class="cebra elevation-2"
                            :headers="pesosArg == 0 ? headerPagos : headerPagosPesos"
                            :items="factura.periodos_pago"
                            dense
                            hide-default-footer
                            :key="keyPagos"
                          >
                            <!-- Importe -->
                            <template v-slot:[`item.importe`]="{ item }">
                              {{ formatMoney(item.importe) }}
                            </template>
                            <!-- Importe Pesos -->
                            <template v-slot:[`item.importe_pesos`]="{ item }">
                              {{ formatMoney(item.importe_pesos) }}
                            </template>
                            <!-- Sin Detalles -->
                            <template v-slot:no-data>
                              <v-alert
                                class="mx-auto mt-4"
                                max-width="400"
                                type="warning"
                                border="left"
                                dense
                                text
                              >
                                No hay Pagos asociados a la Factura
                              </v-alert>
                            </template>
                            <!-- ultima row para el total -->
                            <template slot="body.append">
                              <template v-if="pesosArg == 0">
                                <tr class="font-weight-bold">
                                  <th></th>
                                  <th></th>
                                  <th class="text-right">{{ formatMoney(factura.periodos_pago.reduce((sum, item) => sum + roundNumber(item.importe, 6), 0)) }}</th>
                                  <th class="text-center">{{ factura.periodos_pago.reduce((sum, item) => sum + roundNumber(item.porcentaje, 6), 0) }}%</th>
                                </tr>
                              </template>
                              <template v-else>
                                <tr class="font-weight-bold">
                                  <th></th>
                                  <th></th>
                                  <th class="text-right">{{ formatMoney(factura.periodos_pago.reduce((sum, item) => sum + roundNumber(item.importe_pesos, 6), 0)) }}</th>
                                  <th class="text-center">{{ factura.periodos_pago.reduce((sum, item) => sum + roundNumber(item.porcentaje, 6), 0) }}%</th>
                                </tr>
                              </template>
                            </template>
                            <!-- Acciones -->
                            <template v-slot:[`item.acciones`]="{ item }" v-if="factura.estado_control_id != 4 && factura.estado_codigo != 3">
                              <v-tooltip top color="info">
                                <template v-slot:activator="{ on }">
                                  <v-btn small icon color="info" v-on="on">
                                    <v-icon small>fas fa-info-circle</v-icon>
                                  </v-btn>
                                </template>
                                <ul>
                                  <li>Porcentaje: {{ roundNumber(item.porcentaje, 2) }}%</li>
                                  <li>Tipo de Pago: {{ item.tipo_pago_nombre }}</li>
                                </ul>
                              </v-tooltip>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn small icon color="error" @click="quitarPago(item)" v-on="on">
                                    <v-icon small>far fa-times-circle</v-icon>
                                  </v-btn>
                                </template>
                                <span>Quitar</span>
                              </v-tooltip>
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- Imagenes subidas -->
                <v-col cols="12" sm="6" class="text-center">
                  <v-skeleton-loader
                    v-if="loadImg && !objetoNoVacio(factura)"
                    class="mx-auto"
                    max-width="300"
                    type="card"
                  ></v-skeleton-loader>
                  <template v-else>
                    <template v-if="(selected[0].con_archivo > 0 || selected[0].archivos.length > 0)">
                      <v-row :no-gutters="$vuetify.breakpoint.xs">
                        <v-col cols="12" class="pa-0 ma-0">
                          <v-carousel
                            v-model="model"
                            prev-icon="fas fa-angle-left"
                            next-icon="fas fa-angle-right"
                            height="auto"
                            :show-arrows="arrow"
                            hide-delimiters
                          >
                            <div @click="$vuetify.breakpoint.smAndDown ? arrow = !arrow : ''">
                              <v-carousel-item
                                v-for="(item, index) in selected[0].archivos"
                                :key="index"
                              >
                                <div
                                  v-if="item.type.toUpperCase() == '.PDF'"
                                  :style="$vuetify.breakpoint.smAndDown ? 'height: 500px' : 'height: 1000px'"
                                >
                                  Página
                                  <template>
                                    <span :key="keyDiv">
                                      <button :disabled="page <= 1" @click="page--">❮</button>
                                      {{ page }} / {{ item.page }}
                                      <button :disabled="page >= item.page" @click="page++">❯</button>
                                    </span>
                                  </template>
                                  <vue-pdf-embed
                                    v-if="item.page > 1"
                                    :ref="`pdfRef${index}`"
                                    :source="`data:application/pdf;base64,${item.file}`"
                                    :page="page"
                                    @rendered="handleDocumentRender"
                                  ></vue-pdf-embed>
                                  <vue-pdf-embed
                                    v-else
                                    :ref="`pdfRef${index}`"
                                    :source="`data:application/pdf;base64,${item.file}`"
                                    @rendered="handleDocumentRender"
                                  ></vue-pdf-embed>
                                </div>
                                <template v-else>
                                  <v-btn
                                    style="position:absolute; z-index:1;"
                                    class="mt-2 ml-n5"
                                    title="Rotar -90°"
                                    x-small
                                    fab
                                    @click="rotar -= 90"
                                  >
                                    <v-icon small>fas fa-undo</v-icon>
                                  </v-btn>
                                  <v-btn
                                    style="position:absolute; z-index:1;"
                                    class="mt-2 ml-5"
                                    title="Rotar +90°"
                                    x-small
                                    fab
                                    @click="rotar += 90"
                                  >
                                    <v-icon small>fas fa-redo</v-icon>
                                  </v-btn>
                                  <v-zoomer
                                    ref="zoomer"
                                    pivot="cursor"
                                    style="height: 600px"
                                    :mouseWheelToZoom="false"
                                  >
                                    <img
                                      :src="`data:image/jpeg;base64,${item.file}`"
                                      :style="`object-fit: contain; width: 100%; height: 100%; transform: rotate(${rotar}deg);`"
                                    >
                                  </v-zoomer>
                                </template>
                              </v-carousel-item>
                            </div>
                          </v-carousel>
                        </v-col>
                        <v-col cols="12" class="pa-2" v-if="cajaFile == 1">
                          <v-alert
                            class="mx-auto"
                            max-width="400"
                            type="warning"
                            border="left"
                            dense
                            text
                          >
                            Este archivo proviene de Caja
                          </v-alert>
                        </v-col>
                      </v-row>
                      <div class="my-2">
                        <v-btn
                          v-for="i in selected[0].archivos.length"
                          :key="i-1"
                          icon
                          @click="model = i-1"
                        >
                          <v-icon small>{{ i-1 === model ? 'fas fa-circle' : 'far fa-circle' }}</v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <v-alert
                      v-else
                      class="mx-auto mt-4"
                      max-width="400"
                      type="warning"
                      border="left"
                      dense
                      text
                    >
                      No se encontraron archivos para esta Factura
                      <v-btn
                        color="indigo"
                        class="my-1"
                        small
                        @click="subirFile(selected[0])"
                        v-if="factura.estado_control_id != 4 && factura.estado_codigo != 3"
                      >
                        Subir
                        <v-icon small right>fas fa-cloud-upload-alt</v-icon>
                      </v-btn>
                    </v-alert>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </section>
      </v-expand-transition>
    </v-col>
    <!-- Botones Flotantes -->
    <template>
      <v-btn
        color="info"
        class="mb-2"
        style="margin-right: 135px"
        title="Registro anterior"
        :disabled="selected.length == 0"
        :dark="selected.length > 0"
        bottom
        right
        fixed
        small
        fab
        @click="rowAnterior()"
      >
        <v-icon>fas fa-arrow-left</v-icon>
      </v-btn>
      <v-btn
        color="info"
        class="mb-2"
        title="Siguiente registro"
        style="margin-right: 80px"
        :disabled="selected.length == 0"
        :dark="selected.length > 0"
        bottom
        right
        fixed
        small
        fab
        @click="siguienteRow()"
      >
        <v-icon>fas fa-arrow-right</v-icon>
      </v-btn>
      <v-btn
        color="success"
        class="mr-2"
        title="Guardar cambios"
        :disabled="facturasCompra.length == 0"
        :dark="facturasCompra.length != 0"
        bottom
        right
        fixed
        fab
        @click="dialogConfUpdate = true"
      >
        <v-icon>fas fa-save</v-icon>
      </v-btn>
    </template>
    <!-- Menu del Click Derecho -->
    <v-menu
      v-model="menu.activo"
      :position-x="menu.x"
      :position-y="menu.y"
      absolute
      offset-y
    >
      <v-list>
        <v-list-item
          @click="dialogVerOrdCompra.activo = true; dialogVerOrdCompra.factura_id = actualFacturaCompra.factura_id"
        >
          <v-list-item-title>
            <v-icon color="success" small left>fas fa-clipboard-list</v-icon>
            Ordenes de Compra
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          @click="dialogVerRecepciones.factura_id = actualFacturaCompra.factura_id; dialogVerRecepciones.activo = true;"
        >
          <v-list-item-title>
            <v-icon color="info" small left>fas fa-list</v-icon>
            Recepciones
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          @click="pagar()"
        >
          <v-list-item-title>
            <v-icon color="rowsel" small left>fas fa-money-check-alt</v-icon>
            Pagar
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          :disabled="this.actualFacturaCompra.if_anula != 1"
          @click="dialogConfAnular = true"
        >
          <v-list-item-title>
            <v-icon color="error" small left>fas fa-ban</v-icon>
            Anular
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- Modal Ver Recepciones -->
    <ModalVerRecepciones 
      :datos="dialogVerRecepciones"
      @setearModalVerRecep="setModalVerRecep"
    />
    <!-- Modal Ver Ordenes de Compra -->
    <ModalVerOrdCompra 
      :datos="dialogVerOrdCompra"
      @setearModalVerOrdComp="setModalVerOrdComp"
    />
    <!-- Modal generar Pago de Facturas -->
    <ModalPagarFacturasCompra 
      :datos="dialogPagar"
      @setearIngPagoFCComp="setIngPagoFCComp"
      @setExitoPagos="buscar"
    />
    <!-- Modal Confirmar Accion -->
    <ModalConfirmar 
      :activoDialog="dialogConfAsociar"
      :texto="`¿Está seguro de marcar como PAGADAS todas las facturas seleccionadas?`"
      @action="marcarPagadas()"
      @setearModalConfAccion="setModalAsociar"
    />
    <!-- 08-01-2025 por MMURILLO, Modal para cambiar estados de control -->
    <ModalCambiarEstCtlFC 
      :datos="dialogCambEstCtl"
      @setearModalCambEstCtlFC="setModalCambEstCtlFC"
      @succesChangeFC="buscar()"
    />
    <!-- Modal Confirmar Anular Factura -->
    <ModalConfirmar 
      :activoDialog="dialogConfAnular"
      :texto="`¿Está seguro de anular la Factura de Compra ${actualFacturaCompra.factura_id}?`"
      @action="anularFacturaCompra()"
      @setearModalConfAccion="setModalAsociar"
    />
    <!-- Modal Agregar Detalles a Factura de Compra -->
    <ModalArtConcepProv 
      :datos="dialogArtConcep"
      @setearModalArtConc="setModalArtConc"
      @setItem="addDetalle"
    />
    <!-- Modal Agregar Retenciones Especiales -->
    <ModalSelectRetEsp 
      :datos="dialogRetEsp"
      @setearModalRetEsp="setModalRetEsp"
      @setRetEsp="addRetEsp"
      @modRetEsp="editRetEsp"
    />
    <!-- Modal Agregar Periodos de Pago -->
    <ModalSelectPagos 
      :datos="dialogPagos"
      @setearModalPagos="setModalPagos"
      @setPeriodoPago="addPeriodoPago"
    />
    <!-- Modal Editar Detalle de Factura -->
    <ModalSelectDetalle 
      :datos="dialogDetalle"
      @setearModalDetalle="setModalDetalle"
      @setDetalle="editDetalle"
    />
    <!-- Modal Confirmar Guardar Cambios -->
    <ModalConfirmar 
    :activoDialog="dialogConfUpdate"
      :texto="`¿Está seguro de guardar todos los Cambios realizados en las Facturas?`"
      @action="guardar()"
      @setearModalConfAccion="setModalAsociar"
    />
  </v-row>
</template>

<script>
import FechaPicker from '../../components/util/FechaPicker.vue'
import FechaPickerRango from '../../components/util/FechaPickerRango.vue'
import BtnFiltro from '../../components/util/BtnFiltro.vue'
import moment from 'moment'
import SearchDataTable from '../../components/util/SearchDataTable.vue'
import BtnConfirmar from '../../components/util/BtnConfirmar.vue'
import { format_money, roundNumber, objetoNoVacio, cadenaVacia, characterCount, difObjetos } from '../../util/utils'
import ModalSubirArchivos from '../../components/generales/facturasCompra/ModalSubirArchivos.vue'
import ModalVerRecepciones from '../../components/ordenes-compra/ModalVerRecepciones.vue'
import ModalVerOrdCompra from '../../components/ordenes-compra/ModalVerOrdCompra.vue'
import ModalPagarFacturasCompra from '../../components/administracion/ModalPagarFacturasCompra.vue'
import ModalUploadImgGral from '../../components/generales/ModalUploadImgGral.vue'
import ModalConfirmar from '../../components/util/ModalConfirmar.vue'
import ModalCambiarEstCtlFC from '../../components/administracion/ModalCambiarEstCtlFC.vue'
import TextFieldMoney from '../../components/util/TextFieldMoney.vue'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
import ModalArtConcepProv from '../../components/administracion/ModalArtConcepProv.vue'
import ModalSelectRetEsp from '../../components/administracion/ModalSelectRetEsp.vue'
import ModalSelectPagos from '../../components/administracion/ModalSelectPagos.vue'
import ModalSelectDetalle from '../../components/administracion/ModalSelectDetalle.vue'
export default {
  data() {
    return {
      formatMoney: format_money,
      roundNumber: roundNumber,
      objetoNoVacio: objetoNoVacio,
      cadenaVacia: cadenaVacia,
      panel: 0,
      keyVerif: 0,
      idFactura: '',
      check_general: false,
      check_verif: false,
      selectedEstado: {},
      estados: [],
      fechaDesde: '',
      fechaHasta: '',
      fechaRango: [ null , null ],
      limpiarFecha: false,
      tipoFactura: '',
      emision: '',
      numero: '',
      referencia: '',
      usuario: '',
      selectedSucursal: {},
      sucursales: [],
      selectedProveedor: {},
      proveedores: [],
      selectedEmpresa: {},
      empresas: [],
      cond_pago: [],
      big: false,
      load: false,
      facturasCompra: [],
      rangoDef: 6,
      headers: [
        { text: 'Id', align: 'center', value: 'factura_id' },
        { text: 'Fecha', align: 'center', value: 'fecha' },
        { text: 'Proveedor', align: 'left', value: 'proveedor_nombre' },
        { text: 'Concepto', align: 'left', value: 'concepto' },
        //{ text: 'Sucursal', align: 'left', value: 'sucursal_nombre' },
        //{ text: 'Estado', align: 'center', value: 'estado_nombre' },
        { text: 'Estado Control', align: 'center', value: 'estado_control_nombre' },
        //{ text: 'Usuario', align: 'center', value: 'usuario' },
        { text: 'Emis-Nro', align: 'left', value: 'comprobante' },
        //{ text: 'Moneda', align: 'left', value: 'moneda_nombre' },
        //{ text: 'Factura', align: 'center', value: 'tipo_factura' },
        { text: 'Total Cot.', align: 'right', value: 'total_recalculado' },
        { text: 'Total Ars', align: 'right', value: 'total_real' },
        { text: '', align: 'center', value: 'advertencia', width: '1' },
        { text: '', align: 'center', value: 'check_verif', width: '1' },
        { text: 'Acciones', align: 'center', value: 'acciones' }
      ],
      headerSelect: [
        { text: 'Id', align: 'center', value: 'factura_id' },
        { text: 'Fecha', align: 'center', value: 'fecha' },
        { text: 'Proveedor', align: 'left', value: 'proveedor_nombre' },
        { text: 'Concepto', align: 'left', value: 'concepto' },
        { text: 'Estado Control', align: 'center', value: 'estado_control_nombre' },
        { text: 'Emis-Nro', align: 'left', value: 'comprobante' },
        { text: 'Total Cot.', align: 'right', value: 'total_recalculado' },
        { text: 'Total Ars', align: 'right', value: 'total_real' }
      ],
      search: '',
      ruta_carpeta: '/facturas_compras/',
      dialogSubirArchivo: false,
      facturaSeleccionada: '',
      actualFacturaCompra: {},
      menu: {
        activo: false,
        x: 0,
        y: 0
      },
      dialogVerOrdCompra: {
        activo: false,
        orden_id: 0,
        factura_id: 0,
        auditoria: 0, //se marca en 1 cuando es auditoria, 0 si es administración
        proveedor_codigo: 0, //se usa para buscar el proveedor
      },
      dialogVerRecepciones: {
        activo: false,
        orden_id: 0,
        factura_id: 0,
        auditoria: 0, //se marca en 1 cuando es auditoria, 0 si es administración
        proveedor_codigo: 0, //se usa para buscar el proveedor
      },
      dialogPagar: {
        activo: false,
        proveedor_codigo: '',
        proveedor_nombre: '',
        facturas: []
      },
      selected: [],
      selectedEstadoControl: {},
      estadosControl: [],
      disabledCount: 0,
      dialogSubirImgs: {
        activo: false,
        icono: 'fas fa-eye',
        titulo_modal: 'Archivos para La Orden de Pago ',
        tipos: ['.jpg', '.png', '.webp', '.pdf'], // formatos admitidos
        multiple: true,
        max_size: 1, // tamaño del archivo en megas
        ruta: '', // ruta del archivo
        raiz: 0, // indica si vamos a trabajar con la raiz del 10.40 o la de jarvis 2
        tabla: 6, // indica la tabla donde va el log
        id: 0, // generalmente indica un numero identificador para la tabla del log, por ejemplo para facturas de compra seria el id de la factura de compra en la tabla LOG_FACTURAS_COMPRAS en el campo FACTURA_COMPRA_ID
        permiso_borrar: 0 // permiso para borrar archivos
      },
      ordenPago: '',
      dialogConfAsociar: false,
      dialogConfAnular: false,
      dialogConfUpdate: false,
      tienePermiso: 0,
      totalSeleccionado: 0,
      dialogCambEstCtl: {
        activo: false,
        facturas: [],
        estados_control: []
      },
      singleSelect: false,
      factura: {},
      tiposComp: [],
      monedas: [],
      tiposItems: [{tipo_id: 1, tipo_nombre: 'Artículos', abreviatura: 'Art.'}, {tipo_id: 2, tipo_nombre: 'Conceptos', abreviatura: 'Conc.'}, {tipo_id: 3, tipo_nombre: 'Todos', abreviatura: 'TODOS'}],
      boolString: "true",
      totalPesos: 0,
      headerFC: [
        { text: 'Nom.', align: 'left', value: 'concepto_nombre' },
        { text: 'Iva', align: 'right', value: 'iva', formatter: format_money },
        { text: 'Total', align: 'right', value: 'importe', formatter: format_money },
        { text: '', align: 'center', value: 'acciones', sorteable: false }
      ],
      headerFCPesos: [
        { text: 'Nom.', align: 'left', value: 'concepto_nombre' },
        { text: 'Iva', align: 'right', value: 'iva_pesos', formatter: format_money },
        { text: 'Total', align: 'right', value: 'importe_pesos', formatter: format_money },
        { text: '', align: 'center', value: 'acciones', sorteable: false }
      ],
      headerRet: [
        { text: 'Nom.', align: 'left', value: 'descripcion' },
        { text: 'Tipo', align: 'left', value: 'tipo' },
        { text: 'Total', align: 'right', value: 'importe', formatter: format_money },
        { text: '', align: 'center', value: 'acciones', sorteable: false }
      ],
      headerRetPesos: [
        { text: 'Nom.', align: 'left', value: 'descripcion' },
        { text: 'Tipo', align: 'left', value: 'tipo' },
        { text: 'Total', align: 'right', value: 'importe_pesos', formatter: format_money },
        { text: '', align: 'center', value: 'acciones', sorteable: false }
      ],
      headerPagos: [
        { text: 'Fecha', align: 'left', value: 'fecha' },
        { text: 'F. Pago', align: 'left', value: 'compra_fp_nombre' },
        { text: 'Total', align: 'right', value: 'importe', formatter: format_money },
        { text: '', align: 'center', value: 'acciones', sorteable: false }
      ],
      headerPagosPesos: [
        { text: 'Fecha', align: 'left', value: 'fecha' },
        { text: 'F. Pago', align: 'left', value: 'compra_fp_nombre' },
        { text: 'Total', align: 'right', value: 'importe_pesos', formatter: format_money },
        { text: '', align: 'center', value: 'acciones', sorteable: false }
      ],
      arrow: true,
      keyDiv: 0,
      model: 0,
      page: 1,
      rotar: 0,
      loadImg: false,
      keyDetalles: 0,
      keyRetenciones: 0,
      keyPagos: 0,
      dialogRetEsp: {
        activo: false,
        factura_id: 0,
        retenciones_especiales: [],
        retencion: {}
      },
      dialogPagos: {
        activo: false,
        formas_pago: [],
        tipos_pagos: [],
        factura_id: 0,
        porcentaje_acumulado: 0,
        total_factura: 0,
        importe_acumulado: 0
      },
      dialogDetalle: {
        activo: false,
        detalle: [],
        tipo_factura: ''
      },
      dialogArtConcep: {
        activo: false,
        articulos: [],
        conceptos: [],
        tipo_ingresos: []
      },
      facturaCopy: {},
      dialogSubirFile: false,
      facturasAdmin: [],
      facturasAdminCopy: [],
      pantallaChica: this.$vuetify.breakpoint.xs,
      pantallaMediana: this.$vuetify.breakpoint.sm,
      fact_comp_pagos_header:{
        'Id':             'factura_id',
        'Fecha':          'fecha',
        'Proveedor':      'proveedor_nombre',
        'Concepto':       'concepto',
        'Sucursal':       'sucursal_nombre',
        'Estado':         'estado_nombre',
        'Estado Control': 'estado_control_nombre',
        'Usuario':        'usuario',
        'Emis-Nro':       'comprobante',
        'Moneda':         'moneda_nombre',
        'Factura':        'tipo_factura',
        'Total Cot.':     'total_recalculado',
        'Total Ars':      'total_real',
        'Fechas de Pagos':'fecha_pagos', 
      },
      fact_comp_pagos_list: [],
      cajaFile: 0,
      pesosArg: 0,
      multiCuentas: []
    }
  },
  components: {
    FechaPicker,
    BtnFiltro,
    SearchDataTable,
    BtnConfirmar,
    ModalSubirArchivos,
    FechaPickerRango,
    ModalVerRecepciones,
    ModalVerOrdCompra,
    ModalPagarFacturasCompra,
    ModalUploadImgGral,
    ModalConfirmar,
    ModalCambiarEstCtlFC,
    TextFieldMoney,
    VuePdfEmbed,
    ModalArtConcepProv,
    ModalSelectRetEsp,
    ModalSelectPagos,
    ModalSelectDetalle
  },
  created(){
    this.iniciarFormulario()
  },
  methods: {
    async iniciarFormulario(){
      this.$store.state.loading = true
      this.empresas = JSON.parse(localStorage.getItem('empresas'))
      this.sucursales = JSON.parse(localStorage.getItem('sucursales'))
      if (localStorage.getItem('facturas_admin') && localStorage.getItem('facturas_admin_copy')){
        this.facturasAdmin = JSON.parse(localStorage.getItem('facturas_admin'))
        this.facturasAdminCopy = JSON.parse(localStorage.getItem('facturas_admin_copy'))
      }
      this.selectedEmpresa = this.empresas.find(element => element.id == 2) ? this.empresas.find(element => element.id == 2) : {}
      // 08-01-2025 por MMURILLO, cargo los datos del filtro
      let filtroUser = {}
      if (localStorage.getItem('filtrosFCAdmin')){
        filtroUser = JSON.parse(localStorage.getItem('filtrosFCAdmin'))
        if (objetoNoVacio(filtroUser)){
          if (!cadenaVacia(filtroUser.empresa_id)) this.selectedEmpresa = this.empresas.filter(element => element.id == filtroUser.empresa_id).length > 0 ? this.empresas.filter(element => element.id == filtroUser.empresa_id)[0] : {}
          if (!cadenaVacia(filtroUser.fecha_rango_value)) this.rangoDef = filtroUser.fecha_rango_value
          if (!cadenaVacia(filtroUser.factura_id)) this.idFactura = filtroUser.factura_id
          if (!cadenaVacia(filtroUser.tipo_factura)) this.tipoFactura = filtroUser.tipo_factura
          if (!cadenaVacia(filtroUser.emision)) this.emision = filtroUser.emision
          if (!cadenaVacia(filtroUser.numero)) this.numero = filtroUser.numero
          if (!cadenaVacia(filtroUser.referencia)) this.referencia = filtroUser.referencia
          if (!cadenaVacia(filtroUser.usuario)) this.usuario = filtroUser.usuario
          if (!cadenaVacia(filtroUser.sucursal_id)) this.selectedSucursal = this.sucursales.filter(element => element.id == filtroUser.sucursal_id).length > 0 ? this.sucursales.filter(element => element.id == filtroUser.sucursal_id)[0] : {}
          if (!cadenaVacia(filtroUser.orden_pago)) this.ordenPago = filtroUser.orden_pago
          if (!cadenaVacia(filtroUser.pago_desde)) this.fechaDesde = filtroUser.pago_desde
          if (!cadenaVacia(filtroUser.pago_hasta)) this.fechaHasta = filtroUser.pago_hasta
        }
      }
      // obtener los estados
      this.$store.dispatch('bejerman/get_fc_data')
        .then(response => {
          this.$store.state.loading = false
          if (response.resultado == 1){
            this.estados = response.estados
            this.proveedores = response.proveedores
            this.estadosControl = response.estados_control
            this.dialogCambEstCtl.estados_control = response.estados_control
            this.dialogSubirImgs.permiso_borrar = response.permiso
            this.tienePermiso = response.permiso_pagar
            if (objetoNoVacio(filtroUser)){
              if (!cadenaVacia(filtroUser.estado_id)) this.selectedEstado = this.estados.filter(element => element.estado_id == filtroUser.estado_id).length > 0 ? this.estados.filter(element => element.estado_id == filtroUser.estado_id)[0] : {}
            }else this.selectedEstado = this.estados.find(element => element.estado_id == 1) ? this.estados.find(element => element.estado_id == 1) : {}
            // this.selectedEstadoControl = this.estadosControl.find(element => element.estado_control_id == 2) ? this.estadosControl.find(element => element.estado_control_id == 2) : {}
            //if (!cadenaVacia(filtroUser.estado_id)) this.selectedEstado = this.estados.filter(element => element.estado_id == filtroUser.estado_id).length > 0 ? this.estados.filter(element => element.estado_id == filtroUser.estado_id)[0] : {}
            if (!cadenaVacia(filtroUser.proveedor_id)) this.selectedProveedor = this.proveedores.filter(element => element.proveedor_codigo == filtroUser.proveedor_id).length > 0 ? this.proveedores.filter(element => element.proveedor_codigo == filtroUser.proveedor_id)[0] : {}
            if (objetoNoVacio(filtroUser) && !cadenaVacia(filtroUser.estado_control_id)) this.selectedEstadoControl = this.estadosControl.filter(element => element.estado_control_id == filtroUser.estado_control_id).length > 0 ? this.estadosControl.filter(element => element.estado_control_id == filtroUser.estado_control_id)[0] : {}
          }else{
            this.$store.dispatch('show_snackbar', {
              text: response.msj,
              color: 'error',
            })
            return
          }
        })
        .catch(error => {
          this.$store.state.loading = false
          this.$store.dispatch('show_snackbar', {
            text: 'No se pudo obtener los estados de facturas: ' + error.message,
            color: 'error',
          })
          return
        })
      // condiciones pago
      await this.$store.dispatch('facturasCompra/get_condiciones_pago')
        .then(response => {
          this.$store.state.loading = false
          if (response.resultado == 1) {
            this.cond_pago = response.condiciones
            this.monedas = response.monedas
            this.dialogPagos.tipos_pagos = response.tipos_pagos
          } else {
            this.$store.dispatch('show_snackbar', {
              text: response.msj,
              color: 'error'
            })
            return
          }
        })
        .catch(error => {
          this.$store.state.loading = false
          this.$store.dispatch('show_snackbar', {
            text: 'No se pudo obtener las condiciones de pago: ' + error.message,
            color: 'error'
          })
          return
        })
      // 17-04-2025 por MMURILLO, formas de pago
      this.$store.dispatch('facturasCompra/get_fp_compras')
        .then(response => {
          if (response.resultado == 1){
            this.dialogPagos.formas_pago = response.formas_pago
          }else{
            this.$store.dispatch('show_snackbar', {
              text: response.msj,
              color: 'error',
            })
            return
          }
        })
        .catch(error => {
          this.$store.dispatch('show_snackbar', {
            text: 'No se pudo obtener las formas de pago: ' + error.message,
            color: 'error',
          })
          return
        })
    },
    tipoCompFormat(item){
      return `${item.abreviatura}-${item.tipo_letra}`
    },
    limpiar(){
      this.selectedEstado = {}
      this.selectedEmpresa = {}
      this.selectedSucursal = {}
      this.selectedProveedor = {}
      this.idFactura = ''
      this.tipoFactura = ''
      this.emision = ''
      this.numero = ''
      this.referencia = ''
      this.usuario = ''
      this.limpiarFecha = true
      this.fechaDesde = ''
      this.fechaHasta = ''
      this.ordenPago = ''
    },
    filtros(){
      try{
        return {
          empresa_id: objetoNoVacio(this.selectedEmpresa) ? this.selectedEmpresa.id : null,
          proveedor_id: objetoNoVacio(this.selectedProveedor) ? this.selectedProveedor.proveedor_codigo : null,
          fecha_rango_value: this.rangoDef,
          factura_id: cadenaVacia(this.idFactura) ? null : this.idFactura,
          estado_id: objetoNoVacio(this.selectedEstado) ? this.selectedEstado.estado_id : null,
          tipo_factura: cadenaVacia(this.tipoFactura) ? null : this.tipoFactura,
          emision: cadenaVacia(this.emision) ? null : this.emision,
          numero: cadenaVacia(this.numero) ? null : this.numero,
          referencia: cadenaVacia(this.referencia) ? null : this.referencia,
          usuario: cadenaVacia(this.usuario) ? null : this.usuario,
          sucursal_id: objetoNoVacio(this.selectedSucursal) ? this.selectedSucursal.id : null,
          estado_control_id: objetoNoVacio(this.selectedEstadoControl) ? this.selectedEstadoControl.estado_control_id: null,
          orden_pago: cadenaVacia(this.ordenPago) ? null : this.ordenPago,
          pago_desde: cadenaVacia(this.fechaDesde) ? null : this.fechaDesde,
          pago_hasta: cadenaVacia(this.fechaHasta) ? null : this.fechaHasta
        }
      }catch(error){
        console.log('No se pudo guardar los filtros: ' + error.message)
        return {}
      }
    },
    camposVacios(){
      if (this.idFactura.length == 0 && Object.keys(this.selectedEstado).length == 0 && this.tipoFactura.length == 0 && this.emision.length == 0 && this.numero.length == 0 && this.referencia.length == 0 && this.usuario.length == 0 && Object.keys(this.selectedSucursal).length == 0 && Object.keys(this.selectedProveedor).length == 0 && Object.keys(this.selectedEmpresa).length == 0){
        return true
      }else{
        return false
      }
    },
    async buscar(){
      if (this.camposVacios()){
        this.$store.dispatch('show_snackbar', {
          text: 'Por favor, ingrese algún filtro para empezar la búsqueda.',
          color: 'warning',
        })
        return
      }
      if (localStorage.getItem('filtrosFCAdmin')) localStorage.removeItem('filtrosFCAdmin')
      localStorage.setItem('filtrosFCAdmin', JSON.stringify(this.filtros()))
      // 21-04-2025 por MMURILLO, si tengo algo en los array de facturasAdmin pregunto si el usuario está dispuesto a guardar los cambios realizados
      let buscar = 1
      if (this.facturasAdmin.length > 0){
        await this.$swal.fire({
          icon: 'warning',
          title: `Se encontraron cambios sin guardar ¿Desea cargarlos?`,
          html: `(Si selecciona <strong>No</strong> se perderán los cambios que quedaron sin guardar)`,
          width: '650px',
          confirmButtonText: 'Sí',
          cancelButtonText: 'No',
          showCancelButton: true,
          allowEnterKey: false
        })
          .then(async (res) => {
            if (res.isConfirmed) {
              buscar = 0
              this.buscarModificados()
              return
            }
            else if (res.dismiss === this.$swal.DismissReason.cancel) {
              localStorage.removeItem('facturas_admin')
              localStorage.removeItem('facturas_admin_copy')
              this.facturasAdmin = []
              this.facturasAdminCopy = []
            }
          })
      }
      if (buscar == 0) return
      this.load = true
      this.selected = []
      this.facturasCompra = []
      this.check_verif = false
      this.factura = {}
      this.facturaCopy = {}
      // obtengo los datos de estado, estado de control, empresa, proveedor y sucursal
      let estadoF = 0
      let estadoC = 0
      let empresaF = 0
      let proveedorF = 0
      let sucurusalF = 0
      if (Object.keys(this.selectedEstado).length > 0){
        estadoF = this.selectedEstado.estado_id
      }
      if (Object.keys(this.selectedEstadoControl).length > 0){
        estadoC = this.selectedEstadoControl.estado_control_id
      }
      if (Object.keys(this.selectedEmpresa).length > 0){
        empresaF = this.selectedEmpresa.id
      }
      if (Object.keys(this.selectedProveedor).length > 0){
        proveedorF = this.selectedProveedor.proveedor_codigo
      }
      if (Object.keys(this.selectedSucursal).length > 0){
        sucurusalF = this.selectedSucursal.id
      }
      // fecha hasta
      let fechaHastaBus = ''
      if (this.fechaRango[1] && null || this.fechaRango[1] != undefined && this.fechaRango[1].length > 0){
        fechaHastaBus = moment(this.fechaRango[1]).format('DD/MM/YYYY')
      }
      // 29-05-2023 por MMURILLO, fecha de pago por ordenes de compra
      let fDesde = ''
      if (this.fechaDesde != null && this.fechaDesde != undefined && this.fechaDesde.toString().length > 0) fDesde = this.fechaDesde //moment(this.fechaDesde, 'YYYY-MM-DD').format('DD/MM/YYYY')
      let fHasta = ''
      if (this.fechaHasta != null && this.fechaHasta != undefined && this.fechaHasta.toString().length > 0) fHasta = this.fechaHasta //moment(this.fechaHasta, 'YYYY-MM-DD').format('DD/MM/YYYY')
      // orden de pago
      let oPago = 0
      if (this.ordenPago != null && this.ordenPago != undefined && this.ordenPago != 0 && this.ordenPago.toString().length > 0) oPago = this.ordenPago
      this.$store.dispatch('bejerman/get_facturas_compra_admin', {
        idFactura: this.idFactura,
        estado: estadoF,
        estadoControl: estadoC,
        fechaDesde: moment(this.fechaRango[0]).format('DD/MM/YYYY'),
        fechaHasta: fechaHastaBus,
        tipoFactura: this.tipoFactura.toUpperCase(),
        emision: this.emision,
        numero: this.numero,
        referencia: this.referencia,
        usuario: this.usuario,
        empresa: empresaF,
        proveedor: proveedorF,
        sucursal: sucurusalF,
        fDesde: fDesde,
        fHasta: fHasta,
        ordenPago: oPago
      })
        .then(response => {
          this.load = false
          if (response.resultado == 1){
            this.facturasCompra = response.facturasComp
            for (let id in this.facturasCompra){
              this.facturasCompra[id].fecha = moment(this.facturasCompra[id].fecha).format('DD/MM/YYYY')
            }
          }else{
            this.$store.dispatch('show_snackbar', {
              text: response.msj,
              color: 'error',
            })
            return
          }
        })
        .catch(error => {
          this.load = false
          this.$store.dispatch('show_snackbar', {
            text: 'No se pudo obtener las Facturas de Compra: ' + error.message,
            color: 'error',
          })
          return
        })
    },
    async buscarModificados(){
      this.load = true
      this.selected = []
      this.facturasCompra = []
      this.factura = {}
      this.facturaCopy = {}
      this.check_verif = false
      let factLocal = this.facturasAdmin.map(fact => ({factura_id: fact.factura_id}))
      let factPeticion = await this.$store.dispatch('bejerman/get_facturas_modificadas', {facturas: factLocal})
      this.load = false
      if (factPeticion.resultado == 0){
        this.$store.dispatch('show_snackbar', {
          text: factPeticion.msj,
          color: 'error',
        })
        return
      }
      this.facturasCompra = factPeticion.facturasComp
      for (let id in this.facturasCompra){
        this.facturasCompra[id].fecha = moment(this.facturasCompra[id].fecha).format('DD/MM/YYYY')
      }
    },
    anularFacturaCompra(){
      if (!objetoNoVacio(this.actualFacturaCompra)) return
      this.$store.state.loading = true
      this.$store.dispatch('facturasCompra/anular_factura_compra', {ifFactura: this.actualFacturaCompra.factura_id})
        .then(response => {
          this.$store.state.loading = false
          if (response.resultado == 1){
            this.$store.dispatch('show_snackbar', {
              text: 'Se anuló con éxito la factura seleccionada.',
              color: 'success',
            })
            let pos = this.facturasCompra.indexOf(this.actualFacturaCompra)
            this.facturasCompra[pos].estado_codigo = 3
            this.facturasCompra[pos].estado_nombre = 'ANULADO'
            this.facturasCompra[pos].if_anula = 0
            this.facturasCompra[pos].if_modifica = 0
            // restablezco la factura seleccionada
            this.actualFacturaCompra = {}
          }else{
            // restablezco la factura seleccionada
            this.actualFacturaCompra = {}
            this.$store.dispatch('show_snackbar', {
              text: response.msj,
              color: 'error',
            })
            return
          }
        })
        .catch(error => {
          this.$store.state.loading = false
          this.actualFacturaCompra = {}
          this.$store.dispatch('show_snackbar', {
            text: 'No se pudo anular la Factura: ' + error.message,
            color: 'error',
          })
          return
        })
    },
    subirArchivo(item){
      this.facturaSeleccionada = ''
      // indico la ruta donde se van a guardar los archivos
      this.ruta_carpeta = '/facturas_compras/' + item.factura_id
      this.facturaSeleccionada = item.factura_id.toString()
      // abro el modal
      this.dialogSubirArchivo = true
    },
    subirFile(item){
      // indico la ruta donde se van a guardar los archivos
      this.ruta_carpeta = '/facturas_compras/' + item.factura_id
      this.facturaSeleccionada = item.factura_id.toString()
      // abro el modal
      this.dialogSubirFile = true
    },
    ordenPagoFiles(item){
      // titulo del modal
      this.dialogSubirImgs.titulo_modal = this.dialogSubirImgs.titulo_modal + item.nro_orden_pago
      // ruta de la carpeta donde se deberian encontrar los archivos
      this.dialogSubirImgs.ruta = '/ordenes_pago/' + item.orden_pago_id
      // indico el id identificador de las fotos para la recepción
      this.dialogSubirImgs.id = item.orden_pago_id
      // abro el modal
      this.dialogSubirImgs.activo = true
    },
    closeModalSubirArchivo(){
      this.dialogSubirArchivo = false
      this.dialogSubirFile = false
    },
    openWindow(item){
      let path = '/factura-compra/' + item.factura_id.toString()
      const routeData = this.$router.resolve({ path: path })
      window.open(routeData.href, '_blank')
    },
    crearNuevaFC(){
      this.$router.push({path: '/new-factura-compra'})
    },
    clickDerecho(event, item){
      event.preventDefault()
      this.actualFacturaCompra = {}
      this.menu.activo = false
      this.menu.x = event.clientX
      this.menu.y = event.clientY
      this.$nextTick(() => {
        this.menu.activo = true
        if (item.item.estado_control_id != 4) this.actualFacturaCompra = item.item
      })
    },
    setModalVerRecep(value){
      this.dialogVerRecepciones.activo = value
      if (this.dialogVerRecepciones.activo == false){
        this.actualFacturaCompra = {}
        this.dialogVerRecepciones.factura_id = 0
      }
    },
    setModalVerOrdComp(value){
      this.dialogVerOrdCompra.activo = value
      if (this.dialogVerOrdCompra.activo == false){
        this.actualFacturaCompra = {}
        this.dialogVerOrdCompra.factura_id = 0
      }
    },
    async pagar(){
      if (this.selected.length == 0 && Object.keys(this.actualFacturaCompra).length > 0) this.selected.push(this.actualFacturaCompra)
      // tengo algo seleccionado?
      if (this.selected.length == 0){
        this.$store.dispatch('show_snackbar', {
          text: 'Sin Facturas seleccionadas. No se puede iniciar el pago.',
          color: 'info',
        })
        return
      }
      // 17-07-2023 por MMURILLO, controlo que sean de un mismo proveedor
      // tomo el primer código de proveedor
      let unProv = this.selected[0].proveedor_codigo
      // busco a ver si tengo elementos que contengan un código de proveedor distinto
      let distintos = this.selected.filter(element => element.proveedor_codigo != unProv)
      if (distintos.length > 0){
        // aviso al usuario que debe quedarse con un solo proveedor
        this.$store.dispatch('show_snackbar', {
          text: 'Debe seleccionar únicamente facturas de un solo proveedor.',
          color: 'warning',
        })
        return
      }
      // controlo el estado al momento de abrir el modal
      this.$store.state.loading = true
      let controlPeticion = await this.$store.dispatch('facturasCompra/getEstadoControlActual', {facturas: this.selected})
      this.$store.state.loading = false
      if (controlPeticion.resultado == 0){
        this.$store.dispatch('show_snackbar', {
          text: controlPeticion.msj,
          color: 'error',
        })
        return
      }
      // tengo algo en las pagadas?
      if (controlPeticion.pagadas.length > 0){
        // tengo facturas que ya fueron pagadas, las destildo
        for (let id in controlPeticion.pagadas){
          // paso a quitar
          let unaFactura = this.selected.filter(element => element.factura_id == controlPeticion.pagadas[id].factura_id)
          let pos = this.selected.indexOf(unaFactura[0])
          this.selected.splice(pos, 1)
          // actualizo el estado en los detalles
          let posDet = this.facturasCompra.indexOf(unaFactura[0])
          let det = this.facturasCompra[posDet]
          det.estado_control_id = 4
          det.estado_control_nombre = 'PAGADO'
          Object.assign(this.facturasCompra[posDet], det)
        }
        // doy aviso que se destildaron algunas facturas
        this.$store.dispatch('show_snackbar', {
          text: 'Se seleccionaron Facturas que ya poseían Pagos y las mismas fueron quitadas de su selección. Verifique las facturas seleccionadas y vuelva a iniciar la operación.',
          color: 'info',
        })
        return
      }
      this.dialogPagar.proveedor_codigo = this.selected[0].proveedor_codigo
      this.dialogPagar.proveedor_nombre = this.selected[0].proveedor_nombre
      this.dialogPagar.facturas = this.selected
      this.dialogPagar.activo = true
    },
    setIngPagoFCComp(value){
      this.dialogPagar.activo = value
      if (this.dialogPagar.activo == false){
        this.dialogPagar.facturas = []
        this.dialogPagar.proveedor_nombre = ''
      }
    },
    selectAllToggle(props) {
      if(this.selected.length != this.facturasCompra.length - this.disabledCount) {
          this.selected = [];
          const self = this;
          props.items.forEach(item => {
            if(item.estado_control_id != 4) {
              self.selected.push(item);
            } 
          })
      }else this.selected = []
    },
    seleccionarTodos(){
      if (this.facturasCompra.length > 0){
        // quiere agregar todos los elementos de la tabla, controlo que no se agreguen las que ya estan pagadas ni que sean de proveedores distintos
        let unProv = 0
        if (this.selected.length > 0) unProv = this.selected[0].proveedor_codigo
        // me quedo unicamente con los detalles que no se encuentren pagados
        let noPagados = this.facturasCompra.filter(element => element.estado_control_id != 4)
        // tengo algo para agregar?
        if (noPagados.length == 0) return
        // tengo algo para agregar, controlo unProv
        if (unProv == 0){
          // que unProv sea igual a 0 quiere decir que no tengo nada seleccionado, por lo tanto tengo que pasar a llenar la varible global selected, obtengo el proveedor de noPagados
          unProv = noPagados[0].proveedor_codigo
        }
        // comentado el 17-07-2023 por MMURILLO, dejamos de controlar que sea de un solo proveedor
        // hasta este punto si o si tengo algo en unProv, verifico si todos los detalles de noPagados tienen el mismo proveedor
        // let distintos = noPagados.filter(element => element.proveedor_codigo != unProv)
        // if (distintos.length > 0){
        //   this.$store.dispatch('show_snackbar', {
        //     text: 'Existen distintos proveedores en el listado. No se puede agregar.',
        //     color: 'error',
        //   })
        //   return
        // }
        // si llego hasta aqui, paso a agregar
        for (let id in noPagados){
          // ya existe en el listado selected?
          let existe = this.selected.filter(element => element.factura_id == noPagados[id].factura_id)
          if (existe.length == 0) this.selected.push(noPagados[id])
        }
      }
    },
    quitarTodos(){
      this.selected = []
    },
    async marcarPagadas(){
      this.$store.state.loading = true
      let updatePeticion = await this.$store.dispatch('facturasCompra/marcarFCPagadas', {facturas: this.selected})
      this.$store.state.loading = false
      if (updatePeticion.resultado == 1){
        this.$store.dispatch('show_snackbar', {
          text: 'Las facturas fueron marcadas como pagadas con éxito.',
          color: 'success'
        })
        this.buscar()
      }else{
        this.$store.dispatch('show_snackbar', {
          text: updatePeticion.msj,
          color: 'error'
        })
      }
    },
    setModalUpImg(value){
      this.dialogSubirImgs.activo = value
      if (this.dialogSubirImgs.activo == false){
        this.dialogSubirImgs.icono = 'fas fa-eye'
        this.dialogSubirImgs.titulo_modal = 'Archivos para La Orden de Pago '
      }
    },
    setModalAsociar(value){
      this.dialogConfAsociar = value
      this.dialogConfAnular = value
      this.dialogConfUpdate = value
    },
    changeSize (custom) {
      this.big = custom
    },
    selectOp(value){
      this.rangoDef = value
    },
    setModalCambEstCtlFC(value){
      this.dialogCambEstCtl.activo = value
      if (this.dialogCambEstCtl.activo == false) this.dialogCambEstCtl.facturas = []
    },
    cambiarEstadoControl(){
      this.dialogCambEstCtl.facturas = this.selected
      this.dialogCambEstCtl.activo = true
    },
    seleccionarTodosVerif () {
      for (let item of this.facturasCompra) {
        if (item.alerta != 1 && item.estado_codigo == 1) item.check_verif = true
      }
      this.keyVerif++
    },
    quitarTodosVerif () {
      for (let item of this.facturasCompra) {
        item.check_verif = false
      }
      this.keyVerif++
    },
    async marcarVerificadas () {
      let inputOptions = {}
      for (const cp of this.cond_pago) {
        inputOptions[cp.id] = cp.descripcion
      }
      let inputHTML = Object.entries(inputOptions)
        .map(([key, value]) => `<option value="${key}">${value}</option>`)
        .join('')
      let modal = await this.$swal.fire({
        html: `
          <span style="font-size: 20px;"> ¿Está seguro de marcar como <strong>VERIFICADAS</strong> las
          <strong>${this.facturasCompra.filter(fc => fc.check_verif).length}</strong> facturas seleccionadas? </span>
          <div style="margin-bottom: 10px; margin-top: 10px">
            <select id="opcion" class="swal2-input" style="color: ${this.$vuetify.theme.dark ? 'white' : 'black'};border: 1px solid ${this.$vuetify.theme.dark ? 'white' : 'black'};background-color: ${this.$vuetify.theme.dark ? '#333' : '#fff'}">
              <option value="" selected disabled>Seleccione una Condición de Pago</option>
              ${inputHTML}
            </select>
          </div>
          <div>
            <span style="font-size: 20px">Fecha Contable</span><br/>
            <input type="date" id="fecha" class="swal2-input" style="color: ${this.$vuetify.theme.dark ? 'white' : 'black'};border: 1px solid ${this.$vuetify.theme.dark ? 'white' : 'black'};background-color: ${this.$vuetify.theme.dark ? '#333' : '#fff'};margin-top: 10px">
          </div>
        `,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true,
        allowEnterKey: false,
      })
      if (!modal.isConfirmed) return

      // Obtener los valores ingresados
      const fechaInput = document.getElementById('fecha').value
      const fechaFormateada = fechaInput ? moment(fechaInput).format('DD/MM/YYYY') : null
      const opcionSeleccionada = document.getElementById('opcion').value
      const opcion = opcionSeleccionada ? parseInt(opcionSeleccionada, 10) : 0

      // let modal = await this.$swal.fire({
      //   html: `<span style="font-size: 20px;"> ¿Está seguro de marcar como <strong>VERIFICADAS</strong> las
      //     <strong>${this.facturasCompra.filter(fc => fc.check_verif).length}</strong> facturas seleccionadas? </span>`,
      //   confirmButtonText: 'Confirmar',
      //   cancelButtonText: 'Cancelar',
      //   showCancelButton: true,
      //   allowEnterKey: false,
      //   input: 'select',
      //   inputPlaceholder: 'Seleccione una Condición de Pago',
      //   inputOptions,
      //   inputValidator: (value) => {
      //     if (!value) {
      //       return 'Debe seleccionar una Condición de Pago'
      //     }
      //   }
      // })

      this.$store.state.loading = true
      let result = await this.$store.dispatch('facturasCompra/verificarMasivo', {
        cond_pago: opcion,//modal.value,
        facturas: this.facturasCompra.filter(fc => fc.check_verif).map(fc => fc.factura_id),
        fecha_contable: fechaFormateada
      })
      this.$store.state.loading = false

      await this.$swal.fire({
        icon: result.exito == 1 ? 'success' : 'error',
        title: result.message
      })

      if (result.exito == 1) {
        this.buscar()
      }
    },
    rowClick(item, row){
      if (this.selected.length > 0){
        this.selected = []
        if (row.isSelected){
          let unaFac = this.facturasCompra.filter(element => element.factura_id == item.factura_id)
          let pos = this.facturasCompra.indexOf(unaFac[0])
          this.facturasCompra[pos].selected = 0
          return
        }
      }
      // marco que no la estoy seleccionando desde el checkbox
      item.selected = 1
      this.selected.push(item)
      this.getFacturaData()
    },
    async getFacturaData(){
      this.pesosArg = 0
      this.multiCuentas = []
      // controlo si la factura que estan seleccionando es distinta a la que tengo cargada
      if (objetoNoVacio(this.factura)){
        // controlo si tengo cambios para guardar en localStorage
        if (this.selected[0].factura_id != this.factura.factura_id){
          let original = {}
          let copia = {}
          Object.assign(original, this.factura)
          Object.assign(copia, this.facturaCopy)
          if (JSON.stringify(original) !== JSON.stringify(copia)){
            // controlo si ya existe en el array de cambios
            let repetido = this.facturasAdmin.filter(element => element.factura_id == original.factura_id)
            if (repetido.length > 0){
              let pos = this.facturasAdmin.indexOf(repetido[0])
              this.facturasAdmin.splice(pos, 1)
            }
            this.facturasAdmin.push(original)
            this.facturasAdminCopy.push(copia)
            // guardo en localStorage
            localStorage.setItem('facturas_admin', JSON.stringify(this.facturasAdmin))
            localStorage.setItem('facturas_admin_copy', JSON.stringify(this.facturasAdminCopy))
          }
        }
      }
      // ya lo tenía cargado previamente en localStorage?
      let existe = this.facturasAdmin.filter(element => element.factura_id == this.selected[0].factura_id)
      if (existe.length > 0){
        this.cargarFacturaLocal(existe[0].factura_id)
        return
      }
      this.factura = {}
      this.facturaCopy = {}
      this.$store.state.loading = true
      this.$store.dispatch('facturasCompra/get_an_fc_data', {idFactura: this.selected[0].factura_id})
        .then(async (response) => {
          if (response.resultado == 0){
            this.$store.dispatch('show_snackbar', {
              text: response.msj,
              color: 'error',
            })
            return
          }
          if (response.datos.length == 0){
            this.$store.dispatch('show_snackbar', {
              text: 'No se encontraron datos de la Factura seleccionada.',
              color: 'warning',
            })
            return
          }
          this.factura = response.datos[0]
          this.factura.detalles = response.detalles
          this.factura.retenciones = response.retenciones
          this.factura.periodos_pago = response.periodosPagos
          this.tiposComp = response.tiposFacturas
          this.multiCuentas = response.proveedoresBejerman
          // 06-05-2025 por MMURILLO, redondeo la cotización
          this.factura.cotizacion = roundNumber(this.factura.cotizacion, 2)
          // indexo los detalles y retenciones
          this.indexarDetalles()
          this.indexarRetEsp()
          // acomodo el detalle
          // 05-05-2025 por MMURILLO, recalculo los precios en pesos argentinos en caso que sea de moneda extranjera
          for (let id in this.factura.detalles){
            this.factura.detalles[id].importe = roundNumber(this.factura.detalles[id].precio * parseInt(this.factura.detalles[id].cantidad), 6)
            this.factura.detalles[id].iva = roundNumber(this.factura.detalles[id].iva, 6)
            this.factura.detalles[id].neto = roundNumber(this.factura.detalles[id].neto, 6)
            this.factura.detalles[id].precio = roundNumber(this.factura.detalles[id].precio, 6)
            this.factura.detalles[id].tasa = roundNumber(this.factura.detalles[id].tasa, 3)
          }
          this.completarTotalesPesos()
          // obtengo los archivos subidos
          if (this.factura.con_archivo > 0){
            this.loadImg = true
            let filesPeticion = await this.$store.dispatch('facturasCompra/get_fc_files', {idFactura: this.selected[0].factura_id, raiz: 0, path: '/facturas_compras/' + this.selected[0].factura_id})
            this.loadImg = false
            if (filesPeticion.resultado == 0){
              this.$store.dispatch('show_snackbar', {
                text: filesPeticion.msj,
                color: 'error',
              })
              return
            }
            let files = filesPeticion.archivos
            if (files.length > 0){
              for (let id in files) files[id].page = parseInt(id) + 1
            }
            this.selected[0].archivos = files
          }
          this.cajaFile = 0
          // 29-04-2025 por MMURILLO, si no tiene imagenes subidas, intento obtener los archivos subidos en caja
          if (this.selected[0].archivos.length == 0 && !cadenaVacia(this.factura.comprobante_caja_id) && this.factura.comprobante_caja_id != 0){
            this.loadImg = true
            let filesCaja = await this.$store.dispatch('controlCaja/get_archivos', this.factura.comprobante_caja_id)
            this.loadImg = false
            if (filesCaja.exito == 0){
              this.$store.dispatch('show_snackbar', {
                text: filesCaja.message,
                color: 'error',
              })
              return
            }
            let files = filesCaja.data
            if (files.length > 0){
              for (let id in files){
                files[id].page = parseInt(id) + 1
                files[id].type = files[id].tipo
              }
            }
            this.selected[0].archivos = files
            if (this.selected[0].archivos.length > 0) this.cajaFile = 1
          }
          // 06-05-2025 por MMURILLO, completo los datos de multicuenta
          if (this.factura.multicuenta == 1 && this.multiCuentas.length > 0 && !cadenaVacia(this.factura.proveedor_bejerman_codigo) && this.factura.proveedor_bejerman_codigo != 0){
            let existeProv = this.multiCuentas.filter(element => element.proveedor_codigo == this.factura.proveedor_bejerman_codigo)
            if (existeProv.length == 0) this.multiCuentas.push({
                                          cuit: this.factura.proveedor_cuit.toString(), 
                                          proveedor_codigo: this.factura.proveedor_bejerman_codigo,
                                          proveedor_nombre: this.factura.proveedor_bejerman_nombre
                                        })
            else this.factura.proveedor_bejerman_nombre = existeProv[0].proveedor_nombre
          }
          this.facturaCopy = JSON.parse(JSON.stringify(this.factura))
          //Object.assign(this.facturaCopy, this.factura)
          this.$vuetify.goTo('#unaFC')
        })
        .catch((error) => {
          this.$store.dispatch('show_snackbar', {
            text: 'No se pudo obtener los datos de la Factura seleccionada: ' + error.message,
            color: 'error',
          })
        })
        .finally(() => this.$store.state.loading = false)
    },
    completarTotalesPesos(){
      if (!cadenaVacia(this.factura.moneda_id) && this.factura.moneda_id != 0 && this.factura.moneda_id != 1){
        // acomodo los detalles si es que los tuviera
        if (this.factura.detalles.length > 0){
          for (let id in this.factura.detalles){
            this.factura.detalles[id].importe_pesos = roundNumber(this.factura.detalles[id].importe * roundNumber(this.factura.cotizacion, 6), 6)
            if (this.factura.tipo_factura != 'C') this.factura.detalles[id].iva_pesos = roundNumber(this.factura.detalles[id].iva * roundNumber(this.factura.cotizacion, 6), 6)//roundNumber(this.factura.detalles[id].importe_pesos * this.factura.detalles[id].tasa, 6)
            else this.factura.detalles[id].iva_pesos = this.factura.detalles[id].iva
            this.factura.detalles[id].neto_pesos = roundNumber(this.factura.detalles[id].importe_pesos - this.factura.detalles[id].iva_pesos, 6)
            this.factura.detalles[id].precio_pesos = roundNumber(this.factura.detalles[id].precio * roundNumber(this.factura.cotizacion, 6), 6)
          }
        }
        // acomodo las retenciones si es que las tuviera
        if (this.factura.retenciones.length > 0){
          for (let id in this.factura.retenciones){
            this.factura.retenciones[id].importe_pesos = roundNumber(this.factura.retenciones[id].importe * roundNumber(this.factura.cotizacion, 6), 6)
          }
        }
        // acomodo los periodos de pago
        if (this.factura.periodos_pago.length > 0){
          for (let id in this.factura.periodos_pago){
            this.factura.periodos_pago[id].importe_pesos = roundNumber(this.factura.periodos_pago[id].importe * roundNumber(this.factura.cotizacion, 6), 6)
          }
        }
      }
    },
    async cargarFacturaLocal(id){
      let existe = this.facturasAdmin.filter(element => element.factura_id == id)
      let existeCopy = this.facturasAdminCopy.filter(element => element.factura_id == id)
      if (existeCopy.length == 0 || existe.length == 0){
        this.$store.dispatch('show_snackbar', {
          text: 'No se pudo cargar correctamente los datos de la Factura seleccionada',
          color: 'error',
        })
        let existe = this.facturasAdmin.filter(element => element.factura_id == id)
        let pos = this.facturasAdmin.indexOf(existe[0])
        this.facturasAdmin.splice(pos, 1)
        return
      }
      if (this.tiposComp.length == 0){
        this.$store.state.loading = true
        let tiposPeticion = await this.$store.dispatch('facturasCompra/get_fc_tipos_comprobantes')
        this.$store.state.loading = false
        if (tiposPeticion.resultado == 0){
          this.$store.dispatch('show_snackbar', {
            text: tiposPeticion.msj,
            color: 'error',
          })
          return
        }
        this.tiposComp = tiposPeticion.tiposComp
      }
      this.factura = {}
      this.facturaCopy = {}
      // Object.assign(this.factura, Object(existe[0]))
      // Object.assign(this.facturaCopy, Object(existeCopy[0]))
      let pos = this.facturasAdmin.indexOf(existe[0])
      let pos1 = this.facturasAdminCopy.indexOf(existeCopy[0])
      this.factura = this.facturasAdmin[pos]
      this.facturaCopy = this.facturasAdmin[pos1]
      // indexo los detalles y retenciones
      this.indexarDetalles()
      this.indexarRetEsp()
      if (this.factura.con_archivo > 0){
        this.loadImg = true
        let filesPeticion = await this.$store.dispatch('facturasCompra/get_fc_files', {idFactura: this.selected[0].factura_id, raiz: 0, path: '/facturas_compras/' + this.selected[0].factura_id})
        this.loadImg = false
        if (filesPeticion.resultado == 0){
          this.$store.dispatch('show_snackbar', {
            text: filesPeticion.msj,
            color: 'error',
          })
          return
        }
        let files = filesPeticion.archivos
        if (files.length > 0){
          for (let id in files) files[id].page = parseInt(id) + 1
        }
        this.selected[0].archivos = files
      }
      this.cajaFile = 0
      // 29-04-2025 por MMURILLO, si no tiene imagenes subidas, intento obtener los archivos subidos en caja
      if (this.selected[0].archivos.length == 0 && !cadenaVacia(this.factura.comprobante_caja_id) && this.factura.comprobante_caja_id != 0){
        this.loadImg = true
        let filesCaja = await this.$store.dispatch('controlCaja/get_archivos', this.factura.comprobante_caja_id)
        this.loadImg = false
        if (filesCaja.exito == 0){
          this.$store.dispatch('show_snackbar', {
            text: filesCaja.message,
            color: 'error',
          })
          return
        }
        let files = filesCaja.data
        if (files.length > 0){
          for (let id in files){
            files[id].page = parseInt(id) + 1
            files[id].type = files[id].tipo
          }
        }
        this.selected[0].archivos = files
        if (this.selected[0].archivos.length > 0) this.cajaFile = 1
      }
      // 06-05-2025 por MMURILLO, si es con multicuentas las vuelvo a obtener
      if (this.factura.multicuenta == 1){
        this.$store.state.loading = true
        let multiPeticion = await this.$store.dispatch('facturasCompra/get_multi_proveedor', {
          proveedor_codigo: this.factura.proveedor_codigo, 
          empresa_codigo: this.factura.empresa_codigo
        })
        this.$store.state.loading = false
        if (multiPeticion.resultado == 0){
          this.$store.dispatch('show_snackbar', {
            text: multiPeticion.msj,
            color: 'error',
          })
          return
        }
        this.multiCuentas = multiPeticion.proveedores
        // controlo a ver si tengo 
      }
      this.$vuetify.goTo('#unaFC')
    },
    editarDetalle(item){
      let unItem = {}
      Object.assign(unItem, item)
      this.dialogDetalle.detalle.push(unItem)
      this.dialogDetalle.tipo_factura = cadenaVacia(this.factura.tipo_factura) ? 'B' : this.factura.tipo_factura.toUpperCase()
      this.dialogDetalle.activo = true
    },
    quitarDetalle(item){
      let pos = this.factura.detalles.indexOf(item)
      this.factura.detalles.splice(pos, 1)
      // para renderizar pinche datatable
      this.keyDetalles++
      this.indexarDetalles()
    },
    async editarRetEsp(item){
      if (this.dialogRetEsp.retenciones_especiales.length == 0){
        this.$store.state.loading = true
        let retPeticion = await this.$store.dispatch('facturasCompra/get_retenciones_especiales')
        this.$store.state.loading = false
        if (retPeticion.resultado == 0){
          this.$store.dispatch('show_snackbar', {
            text: retPeticion.msj,
            color: 'error',
          })
          return
        }
        this.dialogRetEsp.retenciones_especiales = retPeticion.retenciones
      }
      Object.assign(this.dialogRetEsp.retencion, item)
      this.dialogRetEsp.factura_id = this.factura.factura_id
      this.dialogRetEsp.activo = true
    },
    quitarRetEsp(item){
      let pos = this.factura.retenciones.indexOf(item)
      this.factura.retenciones.splice(pos, 1)
      this.keyRetenciones++
      this.indexarRetEsp()
    },
    quitarPago(item){
      let pos = this.factura.periodos_pago.indexOf(item)
      this.factura.periodos_pago.splice(pos, 1)
      this.keyPagos++
    },
    handleDocumentRender() {
      this.selected[0].archivos[this.model].page = this.$refs[`pdfRef${this.model}`][0].pageCount
      this.keyDiv++
    },
    async agregarDetalles(){
      if (this.dialogArtConcep.articulos == 0 || this.dialogArtConcep.conceptos == 0){
        this.$store.state.loading = true
        let itemsPeticion = await this.$store.dispatch('facturasCompra/get_art_concepts_data', {
          id_proveedor: this.factura.proveedor_codigo, 
          empresa_id: this.factura.empresa_codigo
        })
        this.$store.state.loading = false
        if (itemsPeticion.resultado == 0){
          this.$store.dispatch('show_snackbar', {
            text: itemsPeticion.msj,
            color: 'error',
          })
          return
        }
        this.dialogArtConcep.articulos = itemsPeticion.itemsModal.filter(element => element.tipo == 1)
        this.dialogArtConcep.conceptos = itemsPeticion.itemsModal.filter(element => element.tipo == 2)
      }
      if (this.dialogArtConcep.tipo_ingresos.length == 0) this.dialogArtConcep.tipo_ingresos = this.tiposItems.filter(element => element.tipo_id != 3)
      this.dialogArtConcep.activo = true
    },
    addDetalle(item){
      // me fijo si ya existe en el listado
      let existe = this.factura.detalles.filter(element => element.concepto_codigo.toUpperCase() == item.codigo.toUpperCase() && element.tipo == item.tipo)
      if (existe.length > 0){
        this.$store.dispatch('show_snackbar', {
          text: `El detalle ${item.nombre} ya existe en el detalle. No se puede agregar.`,
          color: 'warning',
        })
        return
      }
      // paso a agregar
      let total = roundNumber(parseInt(item.cantidad) * roundNumber(item.precio_s_iva, 6), 6)
      let iva = 0
      if (this.factura.tipo_factura != 'C') iva = roundNumber(total * roundNumber(item.formula, 3), 6)
      let neto = roundNumber(total - iva, 6)
      this.factura.detalles.push({
        cantidad: parseInt(item.cantidad),
        codigo_barras: null,
        compra_id: this.factura.factura_id,
        concepto_codigo: item.codigo,
        concepto_nombre: item.nombre,
        gravamen_codigo: parseInt(item.gravamen_codigo),
        id: null,
        importe: total,
        impuesto: 0,
        iva: iva,
        iva_acrec: null,
        neto: neto,
        precio: roundNumber(item.precio_s_iva, 6),
        tasa: roundNumber(item.formula, 3),
        tasa_impuesto: 0,
        tipo: item.tipo
      })
      // 06-05-2025 por MMURILLO, mando a completar los campos en pesos en caso de corresponder
      this.completarTotalesPesos()
      this.keyDetalles++
      this.indexarDetalles()
      this.$store.dispatch('show_snackbar', {
        text: `El detalle ${item.nombre} fue agregado con éxito.`,
        color: 'success',
      })
    },
    async agregarRetenciones(){
      try{
        if (this.dialogRetEsp.retenciones_especiales.length == 0){
          this.$store.state.loading = true
          let retPeticion = await this.$store.dispatch('facturasCompra/get_retenciones_especiales')
          this.$store.state.loading = false
          if (retPeticion.resultado == 0){
            this.$store.dispatch('show_snackbar', {
              text: retPeticion.msj,
              color: 'error',
            })
            return
          }
          this.dialogRetEsp.retenciones_especiales = retPeticion.retenciones
        }
        this.dialogRetEsp.factura_id = this.factura.factura_id
        this.dialogRetEsp.activo = true
      }catch(error){
        this.$store.dispatch('show_snackbar', {
          text: 'Ocurrió un problema al obtener las retenciones especiales: ' + error.message,
          color: 'error',
        })
        this.dialogRetEsp.retenciones_especiales = []
      }
    },
    setModalRetEsp(value){
      this.dialogRetEsp.activo = value
      if (this.dialogRetEsp.activo == false){
        this.dialogRetEsp.factura_id = 0
        this.dialogRetEsp.retencion = {}
      }
    },
    addRetEsp(item){
      let existe = this.factura.retenciones.filter(element => element.id == item.id)
      if (existe.length > 0){
        this.$store.dispatch('show_snackbar', {
          text: `La Retención ${item.descripcion} ya existe en el listado de Retenciones. No se puede agregar.`,
          color: 'warning',
        })
        return
      }
      this.factura.retenciones.push({
        codigo: item.codigo,
        compra_id: this.factura.factura_id,
        descripcion: item.descripcion,
        id: item.id,
        importe: item.importe,
        tipo: item.tipo_retencion
      })
      // 06-05-2025 por MMURILLO, completo el totales en pesos
      this.completarTotalesPesos()
      this.keyRetenciones++
      this.indexarRetEsp()
      this.$store.dispatch('show_snackbar', {
        text: `La Retención ${item.descripcion} fue agregada con éxito.`,
        color: 'success',
      })
    },
    agregarPagos(){
      this.dialogPagos.factura_id = this.factura.factura_id
      this.dialogPagos.porcentaje_acumulado = this.factura.periodos_pago.reduce((sum, item) => sum + roundNumber(item.porcentaje, 6), 0)
      this.dialogPagos.importe_acumulado = this.factura.periodos_pago.reduce((sum, item) => sum + roundNumber(item.importe, 6), 0)
      this.dialogPagos.total_factura = roundNumber(this.factura.total, 6)
      this.dialogPagos.activo = true
    },
    setModalPagos(value){
      this.dialogPagos.activo = value
      if (this.dialogPagos.activo == false){
        this.dialogPagos.porcentaje_acumulado = 0
        this.dialogPagos.total_factura = 0
        this.dialogPagos.importe_acumulado = 0
        this.dialogPagos.factura_id = 0
      }
    },
    addPeriodoPago(item){
      this.factura.periodos_pago.push({
        compra_fp_id: item.forma_pago_id,
        compra_fp_nombre: this.dialogPagos.formas_pago.filter(element => element.forma_pago_id == item.forma_pago_id)[0].forma_pago_nombre,
        compra_id: this.factura.factura_id,
        fecha: item.fecha_pago,
        id: null,
        importe: item.importe,
        pago: 0,
        porcentaje: item.porcentaje,
        tipo_pago_id: item.tipo_pago_id,
        tipo_pago_nombre: this.dialogPagos.tipos_pagos.filter(element => element.tipo_pago_id == item.tipo_pago_id)[0].tipo_pago_nombre
      })
      // 06-05-2025 por MMURILLO, completo el totales en pesos
      this.completarTotalesPesos()
      this.keyPagos++
      this.$store.dispatch('show_snackbar', {
        text: `Periodo de Pago agregado con éxito.`,
        color: 'success',
      })
    },
    setModalDetalle(value){
      this.dialogDetalle.activo = value
      if (this.dialogDetalle.activo == false){
        this.dialogDetalle.tipo_factura = ''
        this.dialogDetalle.detalle = []
      }
    },
    editDetalle(item){
      let existe = this.factura.detalles.filter(element => element.id_local == item.id_local)
      if (existe.length == 0){
        this.$store.dispatch('show_snackbar', {
          text: 'No se pudo identificar el registro en el Detalle de la Factura.',
          color: 'error',
        })
        return
      }
      let pos = this.factura.detalles.indexOf(existe[0])
      Object.assign(this.factura.detalles[pos], item)
      // 06-05-2025 por MMURILLO, completo los pesos argentinos
      this.completarTotalesPesos()
      this.keyDetalles++
      this.$store.dispatch('show_snackbar', {
        text: `El detalle ${item.concepto_nombre} fue modificado con éxito.`,
        color: 'success',
      })
    },
    indexarDetalles(){
      if (this.factura.detalles.length > 0){
        for (let id in this.factura.detalles){
          this.factura.detalles[id].id_local = parseInt(id)
        }
      }
    },
    indexarRetEsp(){
      if (this.factura.retenciones.length > 0){
        for (let id in this.factura.retenciones){
          this.factura.retenciones[id].id_local = parseInt(id)
        }
      }
    },
    editRetEsp(item){
      let existe = this.factura.retenciones.filter(element => element.id_local == item.id_local)
      if (existe.length == 0){
        this.$store.dispatch('show_snackbar', {
          text: 'No se pudo identificar el registro de la Retención de la Factura.',
          color: 'error',
        })
        return
      }
      // controlo que no haya otra retencion con el mismo codigo
      let repetidos = this.factura.retenciones.filter(element => element.id_local != item.id_local && element.id == item.id)
      if (repetidos.length > 0){
        this.$store.dispatch('show_snackbar', {
          text: 'Ya existe la Retención deseada en el detalle. No se puede modificar.',
          color: 'warning',
        })
        return
      }
      let pos = this.factura.retenciones.indexOf(existe[0])
      Object.assign(this.factura.retenciones[pos], {
        codigo: item.codigo,
        compra_id: this.factura.factura_id,
        descripcion: item.descripcion,
        id: item.id,
        importe: item.importe,
        tipo: item.tipo_retencion,
        id_local: item.id_local
      })
      // 06-05-2025 por MMURILLO, completo el totales en pesos
      this.completarTotalesPesos()
      this.keyRetenciones++
      this.$store.dispatch('show_snackbar', {
        text: `La Retención ${item.descripcion} fue modificada con éxito.`,
        color: 'success',
      })
    },
    rowAnterior(){
      if (this.selected.length == 1){
        let existe = this.facturasCompra.filter(element => element.factura_id == this.selected[0].factura_id)
        if (existe.length == 0){
          this.$store.dispatch('show_snackbar', {
            text: 'No se pudo navegar por el listado de Facturas.',
            color: 'error',
          })
          return
        }
        let pos = this.facturasCompra.indexOf(existe[0])
        if (pos > 0){
          this.facturasCompra[pos].selected = 0
          this.selected = []
          this.facturasCompra[pos-1].selected = 1
          this.selected.push(this.facturasCompra[pos-1])
          this.rotar = 0
          this.getFacturaData()
        }
      }
    },
    siguienteRow(){
      if (this.selected.length == 1){
        let existe = this.facturasCompra.filter(element => element.factura_id == this.selected[0].factura_id)
        if (existe.length == 0){
          this.$store.dispatch('show_snackbar', {
            text: 'No se pudo navegar por el listado de Facturas.',
            color: 'error',
          })
          return
        }
        let pos = this.facturasCompra.indexOf(existe[0])
        if (pos >= 0 && pos != this.facturasCompra.length - 1){
          this.facturasCompra[pos].selected = 0
          this.selected = []
          this.facturasCompra[pos+1].selected = 1
          this.selected.push(this.facturasCompra[pos+1])
          this.rotar = 0
          this.getFacturaData()
        }
      }
    },
    verificarObligatorios(item){
      if (cadenaVacia(item.sucursal_codigo)) return {valido: false, msj: `Completa la Sucursal para la Factura ${item.factura_id}`}
      if (cadenaVacia(item.fecha)) return {valido: false, msj: `Completa la Fecha para la Factura ${item.factura_id}`}
      if (cadenaVacia(item.fecha_contable) || item.fecha_contable == 'Invalid date') return {valido: false, msj: `Completa la Fecha Contable para la Factura ${item.factura_id}`}
      if (cadenaVacia(item.emision)) return {valido: false, msj: `Completa la Emisión para la Factura ${item.factura_id}`}
      if (cadenaVacia(item.numero)) return {valido: false, msj: `Completa el Número para la Factura ${item.factura_id}`}
      if (cadenaVacia(item.tipo_factura_id)) return {valido: false, msj: `Completa el Tipo de Factura para la Factura ${item.factura_id}`}
      if (cadenaVacia(item.total) || item.total == 0) return {valido: false, msj: `Completa el Total para la Factura ${item.factura_id}`}
      if (moment(item.fecha, 'DD/MM/YYYY').toDate() > moment(item.fecha_contable, 'DD/MM/YYYY').toDate()) return {valido: false, msj: `La Fecha del Comprobante no puede ser mayor a la Fecha Contable para la Factura ${item.factura_id}`}
      if (cadenaVacia(item.estado_control_id)) return {valido: false, msj: `Completa el Estado de Control para la Factura ${item.factura_id}`}
      if (!cadenaVacia(item.moneda_id) && item.moneda_id != 0 && item.moneda_id != 1 && cadenaVacia(item.cotizacion)) return {valido: false, msj: `Completa la Cotización para la Factura ${item.factura_id}`}
      if (item.multicuenta == 1 && (cadenaVacia(item.proveedor_bejerman_codigo) || item.proveedor_bejerman_codigo == 0)) return {valido: false, msj: `Completa el Proveedor Bejerman para la Factura ${item.factura_id}`}
      if (cadenaVacia(item.condicion_pago_bejerman) || item.condicion_pago_bejerman == 0) return {valido: false, msj: `Completa la Condición de Pago para la Factura ${item.factura_id}`}
      return {valido: true, msj: 'OK'}
    },
    calcularDiasPago(fecha){
      let fechaActual = moment(new Date())
      let dif = fechaActual.diff(moment(fecha, 'DD/MM/YYYY'), 'days')
      return dif
    },
    async guardar(){
      if (!objetoNoVacio(this.factura)){
        this.$store.dispatch('show_snackbar', {
          text: 'Sin cambios para guardar.',
          color: 'info',
        })
        return
      }
      if (this.facturasAdmin.length == 0){
        let original = {}
        let copia = {}
        Object.assign(original, this.factura)
        Object.assign(copia, this.facturaCopy)
        if (JSON.stringify(original) == JSON.stringify(copia)){
          this.$store.dispatch('show_snackbar', {
            text: 'Sin cambios para aplicar.',
            color: 'info',
          })
          return
        }
      }
      let existe = this.facturasAdmin.filter(element => element.factura_id == this.factura.factura_id)
      let existeCopy = this.facturasAdminCopy.filter(element => element.factura_id == this.factura.factura_id)
      if (existe.length == 0){
        let original = {}
        let copia = {}
        Object.assign(original, this.factura)
        Object.assign(copia, this.facturaCopy)
        if (JSON.stringify(original) != JSON.stringify(copia)){
          this.facturasAdmin.push(original)
          this.facturasAdminCopy.push(copia)
          // guardo en localStorage
          localStorage.setItem('facturas_admin', JSON.stringify(this.facturasAdmin))
          localStorage.setItem('facturas_admin_copy', JSON.stringify(this.facturasAdminCopy))
        }
      }else{
        let pos = this.facturasAdmin.indexOf(existe[0])
        let pos1 = this.facturasAdminCopy.indexOf(existeCopy[0])
        let original = {}
        let copia = {}
        Object.assign(original, this.factura)
        Object.assign(copia, this.facturasAdmin[pos])
        if (JSON.stringify(original) != JSON.stringify(copia)){
          // hicieron cambios, quito los que ya existian
          this.facturasAdmin.splice(pos, 1)
          this.facturasAdminCopy.splice(pos1, 1)
          // paso a guardar los cambios
          this.facturasAdmin.push(original)
          this.facturasAdminCopy.push(copia)
          // guardo en localStorage
          localStorage.setItem('facturas_admin', JSON.stringify(this.facturasAdmin))
          localStorage.setItem('facturas_admin_copy', JSON.stringify(this.facturasAdminCopy))
        }
      }
      if (this.facturasAdmin.length == 0){
        let original = {}
        let copia = {}
        Object.assign(original, this.factura)
        Object.assign(copia, this.facturaCopy)
        if (JSON.stringify(original) != JSON.stringify(copia)){
          this.facturasAdmin.push(original)
          this.facturasAdminCopy.push(copia)
          // guardo en localStorage
          localStorage.setItem('facturas_admin', JSON.stringify(this.facturasAdmin))
          localStorage.setItem('facturas_admin_copy', JSON.stringify(this.facturasAdminCopy))
        }
      }
      // controlo que no hayan facturas en estado pagadas
      this.facturasAdmin = this.facturasAdmin.filter(element => element.estado_control_id != 4)
      // paso a guardar
      let fcActualizar = []
      if (this.facturasAdmin.length > 0){
        // controlo que todas las facturas contenidas en facturasAdmin estén correctas
        for (let id in this.facturasAdmin){
          // controlo obligatorios
          let valido = this.verificarObligatorios(this.facturasAdmin[id])
          if (valido.valido == false){
            this.$store.dispatch('show_snackbar', {
              text: valido.msj,
              color: 'warning',
            })
            return
          }
          // controlo los periodos de pagos
          if (this.facturasAdmin[id].periodos_pago.length > 0){
            let totalPorcentaje = this.facturasAdmin[id].periodos_pago.reduce((sum, item) => sum + roundNumber(item.porcentaje, 6), 0)
            if (roundNumber(totalPorcentaje, 2) != 100){
              this.$store.dispatch('show_snackbar', {
                text: `La factura ${this.facturasAdmin[id].factura_id} no completa el 100% de los Pagos. Revisar.`,
                color: 'warning',
              })
              return
            }
            let totalPagos = this.facturasAdmin[id].periodos_pago.reduce((sum, item) => sum + roundNumber(item.importe, 6), 0)
            if (roundNumber(totalPagos, 2) != roundNumber(this.facturasAdmin[id].total, 2) && Math.abs(roundNumber(totalPagos, 2) - roundNumber(this.facturasAdmin[id].total, 2)) > 1){
              this.$store.dispatch('show_snackbar', {
                text: `La suma de Pagos de la Factura ${this.facturasAdmin[id].factura_id} ($${roundNumber(totalPagos, 2)}) no completa el Total de la misma ($${roundNumber(this.facturasAdmin[id].total)}). Revisar.`,
                color: 'warning',
              })
              return
            }
          }
          // controlo totales
          let subTotal = this.facturasAdmin[id].detalles.reduce((sum, item) => sum + roundNumber(item.importe, 6), 0)
          let totalIva105 = this.facturasAdmin[id].detalles.filter(element => element.gravamen_codigo == 2).reduce((sum, item) => sum + roundNumber(item.iva, 6), 0)
          let totalIva21 = this.facturasAdmin[id].detalles.filter(element => element.gravamen_codigo == 1).reduce((sum, item) => sum + roundNumber(item.iva, 6), 0)
          let totalIva27 = this.facturasAdmin[id].detalles.filter(element => element.gravamen_codigo == 4).reduce((sum, item) => sum + roundNumber(item.iva, 6), 0)
          let ivaTotal = roundNumber(totalIva105 + totalIva21 + totalIva27, 6)
          let netoTotal = this.facturasAdmin[id].detalles.reduce((sum, item) => sum + roundNumber(item.neto, 6), 0)
          let totalRetenciones = this.facturasAdmin[id].retenciones.reduce((sum, item) => sum + roundNumber(item.importe, 6), 0)
          let totalCalculado = roundNumber(subTotal + ivaTotal + totalRetenciones, 2)
          if ((roundNumber(this.facturasAdmin[id].total, 2) - 1) > totalCalculado || (roundNumber(this.facturasAdmin[id].total, 2) + 1) < totalCalculado){
            this.$store.dispatch('show_snackbar', {
              text: `El Total Calculado ${format_money(totalCalculado)} difiere con el Total de la Factura ${format_money(roundNumber(this.facturasAdmin[id].total, 2))} por más de $1 para la Factura ${this.facturasAdmin[id].factura_id}. No se puede guardar los cambios.`,
              color: 'warning',
            })
            return
          }
          // armo la estructura que necesito
          let encabezado = {
            fecha: this.facturasAdmin[id].fecha,
            iva: ivaTotal,
            neto: netoTotal,
            subtotal: subTotal,
            total: roundNumber(this.facturasAdmin[id].total, 2), // 03-09-2024 por MMURILLO, coloco el total del encabezado this.totalFinal.toFixed(2),
            referencia: cadenaVacia(this.facturasAdmin[id].referencia) ? '' : this.facturasAdmin[id].referencia,
            percepcion: totalRetenciones,
            emision: this.facturasAdmin[id].emision,
            numero: this.facturasAdmin[id].numero,
            tipo_factura: this.facturasAdmin[id].tipo_factura,
            tipo_factura_codigo: this.tiposComp.filter(element => element.tipo_id == this.facturasAdmin[id].tipo_factura_id)[0].comp_tipo_id,
            tipo_factura_id: this.facturasAdmin[id].tipo_factura_id,
            usuario: this.facturasAdmin[id].usuario,
            impuesto: 0,
            fecha_pago: moment(new Date()).format('DD/MM/YYYY'),
            dias_pago: this.calcularDiasPago(this.facturasAdmin[id].fecha),
            sucursal: cadenaVacia(this.facturasAdmin[id].sucursal_codigo) ? null : this.facturasAdmin[id].sucursal_codigo,
            id_factura: this.facturasAdmin[id].factura_id,
            fecha_contable: this.facturasAdmin[id].fecha_contable,
            proveedor_codigo: this.facturasAdmin[id].proveedor_codigo,
            empresa_codigo: this.facturasAdmin[id].empresa_codigo,
            proveedor_bejerman: this.facturasAdmin[id].proveedor_bejerman_codigo,
            condicion_pago: cadenaVacia(this.facturasAdmin[id].condicion_pago_bejerman) ? 0 : this.facturasAdmin[id].condicion_pago_bejerman,
            estado_control: this.facturasAdmin[id].estado_control_id,
            cotizacion: this.facturasAdmin[id].cotizacion
          }
          // acomodo los datalles
          let detallesLocal = []
          for (let jd in this.facturasAdmin[id].detalles){
            let unDet = {
              cantidad: this.facturasAdmin[id].detalles[jd].cantidad,
              codigo_barras: cadenaVacia(this.facturasAdmin[id].detalles[jd].codigo_barras) ? '' : this.facturasAdmin[id].detalles[jd].codigo_barras,
              compra_id: this.facturasAdmin[id].detalles[jd].compra_id,
              concepto_codigo: this.facturasAdmin[id].detalles[jd].concepto_codigo,
              concepto_nombre: this.facturasAdmin[id].detalles[jd].concepto_nombre,
              gravamen_codigo: this.facturasAdmin[id].detalles[jd].gravamen_codigo,
              id: this.facturasAdmin[id].detalles[jd].id,
              id_local: this.facturasAdmin[id].detalles[jd].id_local,
              importe: this.facturasAdmin[id].detalles[jd].importe + this.facturasAdmin[id].detalles[jd].iva,
              impuesto: this.facturasAdmin[id].detalles[jd].impuesto,
              iva: this.facturasAdmin[id].detalles[jd].iva,
              iva_acrec: this.facturasAdmin[id].detalles[jd].iva_acrec,
              neto: this.facturasAdmin[id].detalles[jd].importe,
              precio: this.facturasAdmin[id].detalles[jd].precio,
              tasa: this.facturasAdmin[id].detalles[jd].tasa,
              tasa_impuesto: this.facturasAdmin[id].detalles[jd].tasa_impuesto,
              tipo: this.facturasAdmin[id].detalles[jd].tipo,
            }
            detallesLocal.push(unDet)
          }
          // fechas de pago
          let fechasPago = []
          for (let jd in this.facturasAdmin[id].periodos_pago){
            let unPeriodo = {
              fecha_pago: this.facturasAdmin[id].periodos_pago[jd].fecha,
              forma_pago: this.facturasAdmin[id].periodos_pago[jd].compra_fp_nombre,
              forma_pago_id: this.facturasAdmin[id].periodos_pago[jd].compra_fp_id,
              id: this.facturasAdmin[id].periodos_pago[jd].id,
              pago: this.facturasAdmin[id].periodos_pago[jd].pago,
              pago_total: roundNumber(this.facturasAdmin[id].periodos_pago[jd].importe, 6),
              porcentaje_pago: roundNumber(this.facturasAdmin[id].periodos_pago[jd].porcentaje, 6),
              tipo_pago_id: this.facturasAdmin[id].periodos_pago[jd].tipo_pago_id,
              tipo_pago_nombre: this.facturasAdmin[id].periodos_pago[jd].tipo_pago_nombre
            }
            fechasPago.push(unPeriodo)
          }
          // retenciones
          let retencionesLocal = []
          for (let jd in this.facturasAdmin[id].retenciones){
            let unaRetencion = {
              id: this.facturasAdmin[id].retenciones[jd].id,
              retencion_codigo: this.facturasAdmin[id].retenciones[jd].codigo,
              retencion_id: this.facturasAdmin[id].retenciones[jd].id,
              retencion_nombre: this.facturasAdmin[id].retenciones[jd].descripcion,
              retencion_tipo: this.facturasAdmin[id].retenciones[jd].tipo,
              retencion_total: roundNumber(this.facturasAdmin[id].retenciones[jd].importe, 6)
            }
            retencionesLocal.push(unaRetencion)
          }
          // armo mi factura a modificar
          let unaFactura = {
            encabezado: encabezado,
            detalles: detallesLocal,
            retenciones: retencionesLocal,
            periodos_pago: fechasPago
          }
          fcActualizar.push(unaFactura)
        }
        this.$store.state.loading = true
        let updatePeticion = await this.$store.dispatch('facturasCompra/updateFcMasivo', {facturas: fcActualizar})
        this.$store.state.loading = false
        if (updatePeticion.resultado == 0){
          this.$store.dispatch('show_snackbar', {
            text: updatePeticion.msj,
            color: 'warning',
          })
          return
        }
      }
      // limpio todo
      this.facturasAdmin = []
      this.facturasAdminCopy = []
      this.factura = {}
      this.facturaCopy = {}
      localStorage.removeItem('facturas_admin')
      localStorage.removeItem('facturas_admin_copy')
      this.selected = []
      this.facturasCompra = []
      this.pesosArg = 0
      this.$store.dispatch('show_snackbar', {
        text: 'Actualización realizada con éxito.',
        color: 'success',
      })
      this.buscar()
    },
    setFacturaFile(file){
      if (file.exito == 1){
        let page = this.selected[0].archivos.length + 1
        this.selected[0].archivos.push({
          file: file.file,
          name: file.name,
          page: page,
          size: 1,
          type: file.type
        })
        this.factura.con_archivo = (cadenaVacia(this.factura.con_archivo) || this.factura.con_archivo == 0) ? 1 : parseInt(this.factura.con_archivo) + 1
      }
    },
    calcularPesos(){
      if (cadenaVacia(this.factura.cotizacion) || this.factura.cotizacion == 0) this.totalPesos = 0
      else this.totalPesos = roundNumber(roundNumber(this.factura.total, 2) * roundNumber(this.factura.cotizacion, 2), 2)
      // 06-05-2025 por MMURILLO, recalculo los totales de los otros campos
      this.completarTotalesPesos()
    },
    async getFactCompPagos(){
      if (this.facturasCompra.length == 0 ){
        this.$store.dispatch('show_snackbar', {
          text: 'Por favor, realice una busqueda para poder descargar',
          color: 'info',
        })
        return
      }
              
      // obtengo los datos de estado, estado de control, empresa, proveedor y sucursal
      let estadoF = 0
      let estadoC = 0
      let empresaF = 0
      let proveedorF = 0
      let sucurusalF = 0
      if (Object.keys(this.selectedEstado).length > 0){
        estadoF = this.selectedEstado.estado_id
      }
      if (Object.keys(this.selectedEstadoControl).length > 0){
        estadoC = this.selectedEstadoControl.estado_control_id
      }
      if (Object.keys(this.selectedEmpresa).length > 0){
        empresaF = this.selectedEmpresa.id
      }
      if (Object.keys(this.selectedProveedor).length > 0){
        proveedorF = this.selectedProveedor.proveedor_codigo
      }
      if (Object.keys(this.selectedSucursal).length > 0){
        sucurusalF = this.selectedSucursal.id
      }
      // fecha hasta
      let fechaHastaBus = ''
      if (this.fechaRango[1] && null || this.fechaRango[1] != undefined && this.fechaRango[1].length > 0){
        fechaHastaBus = moment(this.fechaRango[1]).format('DD/MM/YYYY')
      }
      // 29-05-2023 por MMURILLO, fecha de pago por ordenes de compra
      let fDesde = ''
      if (this.fechaDesde != null && this.fechaDesde != undefined && this.fechaDesde.toString().length > 0) fDesde = this.fechaDesde //moment(this.fechaDesde, 'YYYY-MM-DD').format('DD/MM/YYYY')
      let fHasta = ''
      if (this.fechaHasta != null && this.fechaHasta != undefined && this.fechaHasta.toString().length > 0) fHasta = this.fechaHasta //moment(this.fechaHasta, 'YYYY-MM-DD').format('DD/MM/YYYY')
      // orden de pago
      let oPago = 0
      if (this.ordenPago != null && this.ordenPago != undefined && this.ordenPago != 0 && this.ordenPago.toString().length > 0) oPago = this.ordenPago

      this.$store.state.loading = true;
      const res                 = await this.$store.dispatch("facturasCompra/getfacturasCompraPagos", { 
        idFactura:     this.idFactura,
        estado:        estadoF,
        estadoControl: estadoC,
        fechaDesde:    moment(this.fechaRango[0]).format('DD/MM/YYYY'),
        fechaHasta:    fechaHastaBus,
        tipoFactura:   this.tipoFactura.toUpperCase(),
        emision:       this.emision,
        numero:        this.numero,
        referencia:    this.referencia,
        usuario:       this.usuario,
        empresa:       empresaF,
        proveedor:     proveedorF,
        sucursal:      sucurusalF,
        fDesde:        fDesde,
        fHasta:        fHasta,
        ordenPago:     oPago
      });
      this.$store.state.loading = false;

      if(res.resultado == 0){
        return this.$store.dispatch('show_snackbar', {text: res.message, color: 'error'});
      }
      this.fact_comp_pagos_list = res.facturasCompra;

      if(this.fact_comp_pagos_list.length == 0){
        this.$store.dispatch('show_snackbar', {text: 'No fue posible descargar el excel, dado que se encuentra vacío.', color: 'info'});
      }

      return this.fact_comp_pagos_list;
    },
    setProvBejerman(){
      if (cadenaVacia(this.factura.proveedor_bejerman_codigo) || this.factura.proveedor_bejerman_codigo == 0){
        this.factura.proveedor_bejerman_nombre = null
        return
      }
      this.factura.proveedor_bejerman_nombre = this.multiCuentas.filter(element => element.proveedor_codigo == this.factura.proveedor_bejerman_codigo)[0].proveedor_nombre
    },
    setModalArtConc(value){
      this.dialogArtConcep.activo = value
      if (this.dialogArtConcep.activo == false){
        this.dialogArtConcep.articulos = []
        this.dialogArtConcep.conceptos = []
      }
    }
  },
  watch: {
    selectedEmpresa: function(){
      if (this.selectedEmpresa == null || this.selectedEmpresa == undefined){
        this.selectedEmpresa = {}
        this.selectedProveedor = {}
      }
    },
    selectedEstado: function(){
      if (this.selectedEstado == null || this.selectedEstado == undefined){
        this.selectedEstado = {}
      }
    },
    selectedProveedor: function(){
      if (this.selectedProveedor == null || this.selectedProveedor == undefined){
        this.selectedProveedor = {}
      }
    },
    selectedSucursal: function(){
      if (this.selectedSucursal == null || this.selectedSucursal == undefined){
        this.selectedSucursal = {}
      }
    },
    selectedEstadoControl: function(){
      if (this.selectedEstadoControl == null || this.selectedEstadoControl == undefined) this.selectedEstadoControl = {}
    },
    selected: function(newVal, oldVal){
      this.totalSeleccionado = 0
      if (this.selected.length == 0 || this.selected.length > 1){
        this.factura = {}
        this.facturaCopy = {}
        for (let id in this.facturasCompra){
          this.facturasCompra[id].selected = 0
          this.facturasCompra[id].archivos = []
        }
      }
      if (this.selected.length == 1){
        let existe = this.facturasCompra.filter(element => element.factura_id == this.selected[0].factura_id)
        let pos = this.facturasCompra.indexOf(existe[0])
        for (let id in this.facturasCompra){
          if (id != pos) this.facturasCompra[id].archivos = []
        }
      }
      // comentado el 17-07-2023 por MMURILLO, dejamos de controlar que sea de un solo proveedor
      if (this.selected.length > 0){
        // // tomo el primer código de proveedor
        // let unProv = this.selected[0].proveedor_codigo
        // // busco a ver si tengo elementos que contengan un código de proveedor distinto
        // let distintos = this.selected.filter(element => element.proveedor_codigo != unProv)
        // if (distintos.length > 0){
        //   // aviso al usuario que debe quedarse con un solo proveedor
        //   this.$store.dispatch('show_snackbar', {
        //     text: 'Debe seleccionar únicamente facturas de un solo proveedor.',
        //     color: 'warning',
        //   })
        //   // limpio la seleccion
        //   this.selected = []
        // }
        for (let id in this.selected){
          this.totalSeleccionado = this.totalSeleccionado + roundNumber(this.selected[id].total_real, 2)
        }
        this.totalSeleccionado = roundNumber(this.totalSeleccionado, 2)
      }
      this.check_general = this.totalSeleccionado != 0
    },
    facturasCompra: function(){
      if (this.facturasCompra.length > 0){
        const self = this;
        this.facturasCompra.map(item => {
          if (item.estado_control_id == 4) self.disabledCount += 1
        })
      }
    },
    factura: function(){
      if (objetoNoVacio(this.factura)){
        this.factura.fecha = (cadenaVacia(this.factura.fecha) || this.factura.fecha == 'Invalid date') ? moment(new Date()).format('DD/MM/YYYY') : moment(this.factura.fecha).format('DD/MM/YYYY')
        // para factura
        if (cadenaVacia(this.factura.fecha) || this.factura.fecha == 'Invalid date') this.factura.fecha = moment(new Date()).format('DD/MM/YYYY')
        else{
          if (characterCount(this.factura.fecha, '/') != 2) this.factura.fecha = moment(this.factura.fecha).format('DD/MM/YYYY')
        }
        if (cadenaVacia(this.factura.fecha_contable) || this.factura.fecha_contable == 'Invalid date') this.factura.fecha_contable = moment(new Date()).format('DD/MM/YYYY')
        else{
          if (characterCount(this.factura.fecha_contable, '/') != 2) this.factura.fecha_contable = moment(this.factura.fecha_contable).format('DD/MM/YYYY')
        }
      }
    },
    'facturaCopy': {
      handler: function(val){
        if (objetoNoVacio(this.facturaCopy)){
          if (cadenaVacia(this.facturaCopy.fecha) || this.facturaCopy.fecha == 'Invalid date') this.facturaCopy.fecha = moment(new Date()).format('DD/MM/YYYY')
          else{
            if (characterCount(this.facturaCopy.fecha, '/') != 2) this.facturaCopy.fecha = moment(this.facturaCopy.fecha).format('DD/MM/YYYY')
          }
          if (cadenaVacia(this.facturaCopy.fecha_contable) || this.facturaCopy.fecha_contable == 'Invalid date') this.facturaCopy.fecha_contable = moment(new Date()).format('DD/MM/YYYY')
          else{
            if (characterCount(this.facturaCopy.fecha_contable, '/') != 2) this.facturaCopy.fecha_contable = moment(this.facturaCopy.fecha_contable).format('DD/MM/YYYY')
          }
          if (cadenaVacia(this.facturaCopy.estado_control_id) || this.facturaCopy.estado_control_id == 0) this.facturaCopy.estado_control_nombre = ''
          else this.facturaCopy.estado_control_nombre = this.estadosControl.filter(element => element.estado_control_id == this.facturaCopy.estado_control_id)[0].estado_control_nombre
        }
      },
      deep: true
    },
    'factura.total': {
      handler: function(val){
        if (objetoNoVacio(this.factura)){
          if (cadenaVacia(this.factura.moneda_id) || this.factura.moneda_id == 0 || this.factura.moneda_id == 1) this.totalPesos = 0
          else this.totalPesos = roundNumber(roundNumber(this.factura.total, 2) * ((cadenaVacia(this.factura.cotizacion) || this.factura.cotizacion == 0) ? 1 : roundNumber(this.factura.cotizacion, 2)), 2)
        }
      },
      deep: true
    },
    model () {
      this.page = 1
    },
    'factura.sucursal_codigo': {
      handler: function(val){
        if (objetoNoVacio(this.factura)){
          if (cadenaVacia(this.factura.sucursal_codigo)) this.factura.sucursal_nombre = null
          else this.factura.sucursal_nombre = this.sucursales.filter(element => element.id == this.factura.sucursal_codigo)[0].nombre
        }
      },
      deep: true
    },
    'factura.tipo_factura_id': {
      handler: function(val){
        if (objetoNoVacio(this.factura)){
          if (cadenaVacia(this.factura.tipo_factura_id) || this.factura.tipo_factura_id == 0) this.factura.tipo_factura = ''
          else this.factura.tipo_factura = this.tiposComp.filter(element => element.tipo_id == this.factura.tipo_factura_id)[0].tipo_letra
        }
      },
      deep: true
    },
    'factura.estado_control_id': {
      handler: function(val){
        if (objetoNoVacio(this.factura)){
          if (cadenaVacia(this.factura.estado_control_id) || this.factura.estado_control_id == 0) this.factura.estado_control_nombre = ''
          else this.factura.estado_control_nombre = this.estadosControl.filter(element => element.estado_control_id == this.factura.estado_control_id)[0].estado_control_nombre
        }
      },
      deep: true
    },
    '$vuetify.breakpoint.xs'(val){
      this.pantallaChica = val;
    },
    '$vuetify.breakpoint.sm'(val){
      this.pantallaMediana = val;
    }
  },
}
</script>

<style>

</style>